
import React from "react";
import { makeStyles,withStyles } from '@material-ui/core/styles';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AephoriaTable from '../comps/aephoriaTable';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import AssignmentIcon from '@material-ui/icons/Assignment';
import * as aserver from '../../APIClient';
import Tooltip from "@material-ui/core/Tooltip";
import VisibilityIcon from '@material-ui/icons/Visibility';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import Modal from '../comps/modal';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Toast from "../comps/alertMessage";
import LoadingBackdrop from '../comps/loadingBackdrop';
import DoneIcon from '@material-ui/icons/Done';
import ProgressBar from "../comps/progressbar";
import Paper from '@material-ui/core/Paper';
import * as utils from "../../Utilities";
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AlertModal from "../comps/alertModal";
import EditIcon from '@material-ui/icons/Edit';
import {isMobile} from 'react-device-detect';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Slider from '@material-ui/core/Slider';
import copyIcon from '../images/Duplicate.png'
import blueCopyIcon from '../images/Duplicate-blue.png'
import sendInviteIcon from '../images/Mail.png'
import sendReportIcon from '../images/Paper airplane.png'
import downloadIcon from '../images/Download.png'
import removeIcon from '../images/Icon user remove.png'
import informationIcon from '../images/Information circle.png'
import reportIcon from '../images/report.png'
import reportsIcon from '../images/reports.png'
import ProjectSelect from "../comps/typeAheadSelect";

const marks = [
  {value: 0,},
  {value: 20,},
  {value: 40,},
  {value: 50,},
  {value: 60,},
  {value: 80,},
  {value: 100,},
];

const languageAbbreviations = {
  "english": "EN",
  "french": "FR",
  "german": "DE",
  "xhosa": "XH",
  "hungarian": "HU",
  "slovak": "SK",
  "spanish": "ES",
  "sesotho": "ST",
  "dutch": "NL",
  "portuguese": "PT",
  //"arabic": "AR",
  "ukrainian": "UK",
  "tsonga": "TS",
  "afrikaans": "AF",
  "italian": "IT",
  "chinese": "ZH",
  "korean": "KO",
  "zulu": "ZU"
};

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    color: 'white !important',
  },
}))(Tooltip);

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const IOSSlider = withStyles({
  root: {
    color: '#3880ff',
    height: 2,
    padding: '25px 0',
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#fff',
    boxShadow: iOSBoxShadow,
    marginTop: -8,
    marginLeft: -6,
    '&:focus, &:hover, &$active': {
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 0px)',
    top: 3,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  mark: {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);

const typeOfTokenOptions = <>
  <option hidden>Type Of Token</option>
  <option value="paid">Billable</option>
  <option value="marketing">Marketing</option>
  <option value="accreditation">Accreditation</option>
  <option value="retest">Re-test</option>
  <option value="probono">Pro Bono</option>
</>

const drawerWidth = 240;
const cClipboardPasteMessage = "We've copied the text with the link to your clipboard. Please paste it here.";
let reportCodesToNames = {
  enneaOverview: 'Enneagram Coach Overview',
  clientSummary: 'Enneagram Overview',
  basic: 'Enneagram Report',
  //combinedCoachOverview: 'Combined Coach Overview',
  combinedClientOverview: 'Combined Overview',
  foundation: 'Combined Report',
  extended: 'Combined+ Report',
  imfCoG: 'Maturity Overview',
  imf: 'Maturity Report'
};

let assessmentTypes = {
  ennea: 'Enneagram',
  EIT: 'Maturity',
  full: 'Combined',
  Enneagram: 'Enneagram',
  IMf: 'Maturity',
  Full: 'Combined',
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  container: {
    // paddingTop: theme.spacing(4),
    // paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));
class Assessments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachId: localStorage.getItem('Id'),
      showToast: false,
      modalIsOpen: false,
      isChecked: false,
      name: "",
      surname: "",
      email: "",
      coachEmailAddress: "",
      impersonator: localStorage.getItem("impersonator"),
      company: "",
      selectValue: "",
      tokenType: "paid",
      pairTokenType: "paid",
      client: "",
      assessmentModalTitle: 'X',
      assessmentModalSubmitFunction: this.handleAddToTeam,
      assessmentModalSubmitCaption: 'X',
      clientUUIDS: [],
      id: "",
      allClients: [],
      addProjectModal: false,
      addToTeamSubmitDisabled: false,
      team: "",
      downloadReportModal: false,
      sendReportModal: false,
      tokenId: "",
      disabled: false,
      disableTypeOfTest: false,
      disableModal: false,
      reports: [],
      imfReport: true,
      fullReport: true,
      enneaReport: true,
      failModal: false,
      level: "",
      message: "",
      guestUuids: "",
      emailAddress: "",
      sendReportName: "",
      items: [],
      selected: 0,
      disableGmail: null,
      failModalText: [],
      successModalText: "",
      mailToAddress: "",
      mailToSubject: "",
      mailToBody: "",
      openBackdrop: false,
      sendInviteOrReport: null,
      sendReport: false,
      completed: 0,
      completedCount: 1,
      showProgressBar: false,
      openHistoryModal: false,
      historyData: [],
      activateFilter: localStorage.getItem("functionFilterId"),
      alertModalTitle: "",
      alertMessage: "",
      openAlertModal: false,
      confirmationFunction: this.confirmationFunction,
      confirmationHeading: "",
      confirmationModal: false,
      previewModal: false,
      devTest: false,
      downloadReportModalTitle: "Download Reports",
      disableCheckBox: false,
      previewExplanation: '',
      editModal: false,
      openEditModal: false,
      editModalArray: [],
      language: "english",
      project: "",
      showDoneTitle: false,
      stopDownload: false,
      sendHistoryTitle: "",
      openPreInviteModal: false,
      listOfReminderNames: [],
      listOfCompletedAssessmentNames: [],
      listOfNotSentInvitesNames: [],
      noInviteToSend: false,
      otherDataExists: null,
      other:"",
      assignSCOModalOpen:false,
      scoLevelWarningModal:false,
      selectedAssessmentUUIDs:[],
      secondaryCoachEmailAddress:"",
      showInvalidEmailAddressText:false,
      revokeSCOModal:false,
      revokeSCOProceedDisabled:false,
      selectedSCO_UUIDs:[],
      uniqueCoachlist: [],
      invalidEmailAddress:true,
      addAssistantModal:false,      
      openMakeHybridModal:false,
      assessmentsToHybridize: [],
      chooseBIO: null,
      selectedAssessments: {
        chooseEnneagram: null,
        chooseIMf: null,
      },
      refresh:false,
      disableProccedButton:true,
      showInfo: false,
      clientListOfAssessments: [],
      openBulkModal: false,
      basic: "",
      clientSummary: "",
      showAutoSend:false,
      assessmentType: "",
      importResultsCheck :false,
      enneaRankingCSV:"",
      scoreSP:0,
      scoreSO:0,
      scoreSX:0,
      disableInputs: false,
      clientUUIDArray:[],
      hasMaturityAccreditation: localStorage.getItem("hasMaturityAccreditation") === "1",
      openWarningModal:false,
      clipboardModal:false,
      clipboardCancel: localStorage.getItem('clipboardCancel'),
      showFailedDownloadModal:false,
      failedDownloads:[],
      imfCoG:"",
      imf:"",
      extended:"",
      foundation:"",
      openViewDetailsModal:false,
      htmlReportsModalContent: null,
      reportsToAutoSend: [],
      showDuplicateUpload: false,
      duplicatedGuests: [],
      bulkUploadFile: null,
      autoSendReportsChanged:"",
      showOtherCheckboxes: true,
      showEnneagramCheckboxes: true,
      coachProjects:[],
      blockFields:false,
      importResultsModal:false,
      hideNameSurnameFields:false,
      coupleModal:false,
      dueDate: "",
      coupleUUIDS:[],
      person1Pronouns: "",
      person2Pronouns: "",
      person1Name: "",
      person2Name: "",
      coupleType:"Romance",
      minDate:"",
      importResultsChecked:false,
    };

    this.fileInputRef = React.createRef();

  }


  correctReportNames = (reportCodesToNames, reports) => {
    const correctedReports = [];
    for (let report of reports) {
      if (reportCodesToNames.hasOwnProperty(report)) {
        correctedReports.push(reportCodesToNames[report]);
      } else {
        correctedReports.push(report);
      }
    }
    return correctedReports;
  };

  // ================== Close modals with esc funtion ================================

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal()
      this.closeOnlyOneModal()
      this.closeBulkUploadModal()
    }
  }

  closeOnlyOneModal=()=>{
    this.setState({
      openWarningModal:false,
      failModalText:[],
    })
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      addProjectModal: false,
      downloadReportModal: false,
      enneaReport: true,
      fullReport: true,
      imfReport: true,
      sendReportModal: false,
      disableTypeOfTest: false,
      disableModal: false,
      coachEmailAddress: localStorage.getItem("coachEmailAddress"),
      team: "",
      reports: [],
      disableGmail: true,
      failModal: false,
      confirmationModal: false,
      openHistoryModal: false,
      historyData: [],
      openAlertModal: false,
      openBackdrop: false,
      disableCheckBox: false,
      previewModal: false,
      failModalText: [],
      successModalText: "",
      previewExplanation: '',
      editModal: false,
      openEditModal: false,
      completedCount: 1,
      clientUUIDS: [],
      showDoneTitle: false,
      stopDownload: false,
      openPreInviteModal: false,
      noInviteToSend: false,
      assignSCOModalOpen:false,
      scoLevelWarningModal:false,
      secondaryCoachEmailAddress: "",
      listOfCompletedAssessmentNames: [],
      revokeSCOModal:false,
      revokeSCOProceedDisabled:false,
      addAssistantModal:false,
      invalidEmailAddress:true,
      showInvalidEmailAddressText:false,
      disabled: false,
      // openBulkModal: false,
      language: "english",
      selectValue: "",
      showAutoSend:false,
      tokenType: "paid",
      pairTokenType: "paid",
      other:"",
      importButton:false,
      importResultsCheck:false,
      name:"",
      surname:"",
      email:"",
      company:"",
      disableInputs:false,
      enneaRankingCSV:"",
      scoreSP:0,
      scoreSO:0,
      scoreSX:0,
      clipboardModal:false,
      showFailedDownloadModal:false,
      basic:"",
      clientSummary:"",
      imfCoG:"",
      imf:"",
      extended:"",
      foundation:"",
      openViewDetailsModal:false,
      htmlReportsModalContent: null,
      showDuplicateUpload: false,
      bulkUploadFile:null,
      autoSendReportsChanged:false,
      project:"",
      showEnneagramCheckboxes: true, 
      showOtherCheckboxes: true,
      importResultsModal:false,
      hideNameSurnameFields:false,
      coupleModal:false,
      addClientButton:false,
    });
    this.emptyDownloadStatus()
  }

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ showToast: false }), 2500);
      }
    );
  }

  closeBulkUploadModal =()=>{
   this.setState({
    openBulkModal:false
   })
  }

  refreshTable = () => {
    window.location.reload(false)
  }
  
  toastMessage = (text, level) => {
    this.setState({
      message: text,
      level: level,
    })
    this.showToast()
  }

  downloadToast = (text, level) => {
    this.setState({
      openBackdrop: false,
      modalIsOpen: false,
      message: text,
      level: level,
      showToast: true
    })
  }


  generateStatus = (record) => {
    let s = [];
    if (record.reminded > 0) {
      s.push(
        <CustomTooltip key={"reminded"} title="Reminded" placement="top">
          <DoneAllIcon className="icon" style={{ "cursor": "pointer" }} onClick={(event) =>{event.stopPropagation(); this.getHistory(record.guestUUID, 'inviteHistory', 'Invite Sent History', 'invites')}} />
        </CustomTooltip>);
    }
    else if (record.userInvite) {
      s.push(
        <CustomTooltip key={"invited"} title="Invited" placement="top">
          <DoneIcon className="icon" style={{ "cursor": "pointer" }} onClick={(event) =>{event.stopPropagation(); this.getHistory(record.guestUUID, 'inviteHistory', 'Invite Sent History', 'invites')}} />
        </CustomTooltip>);
    }
    else {
      s.push(
        <CustomTooltip key={"inviteNotSent"} title="Invite Not Yet Sent" placement="top">
          <MarkunreadMailboxIcon className="icon" />
        </CustomTooltip>)
    }

    if (record.userRegistration) {
      s.push(
        <CustomTooltip key={"registered"} title="Registered" placement="top">
          <DoneIcon className="icon" />
        </CustomTooltip>);
    } else {
      s.push(
        <CustomTooltip key={"notYetRegisted"} title="Not Yet Registered" placement="top">
          <HowToRegIcon className="icon" />
        </CustomTooltip>)
    }

    if (record.userCompletion) {
      s.push(
        <CustomTooltip key={"completed"} title="Completed " placement="top">
          <DoneIcon className="icon" />
        </CustomTooltip>);
    } else {
      s.push(
        <CustomTooltip key={"notYetCompleted"} title="Not Yet Completed" placement="top">
          <AssignmentIcon className="icon" />
        </CustomTooltip>)
    }

    if (record.finalTPR) {
      s.push(
        <CustomTooltip key={"marked"} title="Marked" placement="top">
          <DoneIcon className="icon" />
        </CustomTooltip>);
    } else {
      // eslint-disable-next-line
      if (record.assessmentType === "ennea" || record.assessmentType === "Enneagram" && record.results !== "") {
        s.push(
          <CustomTooltip key={"autoMarked"} title="Auto Marked Enneagram" placement="top">
            <DoneIcon className="icon" />
          </CustomTooltip>);
      }
      else {
        s.push(
          <CustomTooltip key={"notYetMarked"} title="Not Yet Marked" placement="top">
            <VisibilityIcon className="icon" />
          </CustomTooltip>);
      }
    }

    if (record.reportsToAutoSend==='-') {
      // old assessments where we didn't track report downloads.
      if (record.userReport) {
        s.push(
          <CustomTooltip key={"reportSent"} title="Reports Sent" placement="top">
            <DoneIcon className="icon" style={{ "cursor": "pointer" }} onClick={(event) => {event.stopPropagation(); this.getHistory(record.guestUUID, 'sentReportHistory', 'Report Sent History', 'reports')}} />
          </CustomTooltip>);
      } else {
        s.push(
          <CustomTooltip key={"reportsNotYetSent"} title="Reports Not Yet Sent" placement="top">
            <InsertInvitationIcon className="icon" />
          </CustomTooltip>)
      }
    } 
    else {
      // new assessments where we did track report downloads.
      for (var reportStatus of [
        {name: 'Ennea reports',
          status: record.reportStatusEnnea},
        {name: 'IMf-containing reports',
          status: record.reportStatusMaturity}]) {
        var status = reportStatus.status
        if (status==='')
            continue;
        var content = <></>;
        var e = '';
        if (record.assessmentType.toLowerCase() !== 'full') {
          reportStatus.name = 'Reports'
        }
        if (status==='o') {
          content=<RadioButtonUncheckedIcon key={"notyetSentToClient"} className="icon" />;
          e = 'not yet sent to client'
        }
        if (status==='s') {
          content=<RadioButtonCheckedIcon key={"sentButNotDownloaded"} className="icon" />;
          e = 'sent, but not yet downloaded by client';
        }
        if (status==='d') {
          content=<CheckCircleOutlineIcon key={"downloaded"} className="icon" />;
          e = 'downloaded by client';
        }
        var title = `${reportStatus.name} ${e}`;
        var icon = <span className="icon" style={{ "cursor": "pointer" }} onClick={(event) => {event.stopPropagation(); this.getHistory(record.guestUUID, 'sentReportHistory', 'Report Sent History', 'reports')}}>{content}</span>;
        if (status==='o')
          icon = <span className="icon">{content}</span>;
        s.push(
          <CustomTooltip key={reportStatus.name} title={title} placement="top">
            {icon}
          </CustomTooltip>);
      }
    }
    return (s);

  }

  getHistory = async (guestUUID, endpointName, title, historyType) => {
    let historyResponse = await aserver.get(`api/v2/tokens/${guestUUID}/${endpointName}`)
    let haveDataToDisplay = false;
    let dataToDisplay = [];
    if (historyResponse.status === 200 && historyResponse.data.length > 0) {
      haveDataToDisplay = true;
      dataToDisplay = historyResponse.data;
      for (let record of dataToDisplay) {
        aserver.convertUTCToLocal(record, 'createdAt');
        if (record.sentViaServer === 1 || record.sentViaServer === "1") {
          record.sentViaServer = "Sent from aim@aephoria.co.za"
        } else {
          record.sentViaServer = "Sent using your own email client"
        }
        record.isReminder = (record.isReminder === true) ? 'Yes' : 'No';
      }
    };
    this.setState({
      historyData: dataToDisplay,
      openHistoryModal: true,
      noHistoryLogsAvailable: !haveDataToDisplay,
      sendHistoryTitle: title,
      historyType: historyType,
    })
  }

  blankCoach = (clientId) => {
    this.setState({
      name: '',
      surname: '',
      email: '',
      company: '',
      project: '',
      clientId: clientId,
    });
  }

  handleChange = ({ target: { name, value, type } }) => {
    let invalidEmailAddress = this.state.invalidEmailAddress;
    if (type === "email") {
      invalidEmailAddress = !utils.validateEmail(value);
    }  

    this.setState({
      [name]: value,
      invalidEmailAddress,
      showInvalidEmailAddressText: invalidEmailAddress,
    });
  }

  // handleDropdownChange = (e) => {
  //   this.setState({ selectValue: e.target.value });
  // }

  sendDropDown = (e) => {
    this.setState({ serverSending: e.target.value });
  }

  selectedData = (data) => {
    this.setState({
      selected: data
    })
    if (data > 1) {
      this.setState({
        disableGmail: true
      })
    } else {
      this.setState({
        disableGmail: false
      })
    }
  }

  mobileInfoTile = (record)=>{
    return(<>{record.fullname}<br/>{record.clientEmail}</>)
  }

  makeInfoTile = (record) => {
    return(<>{record.fullname}<br/><span style={{cursor:"pointer"}}>{record.clientEmail} <img src={blueCopyIcon} onClick={(event) => { event.stopPropagation(); this.copyTextToClipboard(record.clientEmail, true);}} className="infoTileIcon" alt='icon'/></span><br/>{record.trackingStatus}</>);
  }

  abbreviateLanguage =(language)=>{
    if (languageAbbreviations.hasOwnProperty(language)) {
     return languageAbbreviations[language];
    }
  }

  massageData = (data) => {

    this.setState({
      allClients: data
    })

    let otherDataExists = false;

    for (let record of data) {
      aserver.convertUTCToLocal(record, 'tokenCreatedAt');
      aserver.convertUTCToLocal(record, 'guestRegisteredAt');
      aserver.convertUTCToLocal(record, 'guestCompletedAt');

      if (isMobile) {
        const date = record.guestCompletedAt.slice(0, 10);
        const htmlReportsButton = this.getHTMLReportsButton(record);
        record.guestCompletedAtDisplay = (
          <div className="completeMobileColumn">
           {htmlReportsButton}
            <span>{date}</span>
          </div>
        );
      } else {
        record.guestCompletedAtDisplay = record.guestCompletedAt; 
      }

      if (record.tokenType === "paid") {
        record.tokenType = "Paid"
      }

      if (record.tokenType === "marketing") {
        record.tokenType = "Marketing"
      }

      record.abbreviatedAssessmentLanguage = this.abbreviateLanguage(record.assessmentLanguage)

      if (record.assessmentType === "ennea") {
        record.assessmentType = "Enneagram";
      } else if (record.assessmentType === "EIT") {
          record.assessmentType = "IMf";
      } else if (record.assessmentType === "full") {
          record.assessmentType = "Full";
      }

      let decoratedAssessmentTypeText = record.assessmentType;

      if (record.assessmentType === "Enneagram" || record.assessmentType === "IMf" || record.assessmentType === "Full") {
        let decorations = [];

        if (record.tokenType === "hybrid"){
          decorations.push({text: 'Combo', class: 'chip'});
        } 
        if (record.tokenType === "importResults"){
          decorations.push({text: 'Imported', class: 'chip'});
        }
        if (record.tokenType === "selfRegister"){
          decorations.push({text: 'Self-register', class: 'chip'});
        }
        if (record.parentedHybrid){
          decorations.push({text: 'Parented a Combo', class: 'parentedChip'});
        }

        if (decorations.length > 0) {
          decoratedAssessmentTypeText += ' ' + decorations.map(d=>d.text).join(', ');
        }

        let additionalType = decorations.map((decoration,index)=> {
          return(<div key={index} className={decoration.class}>{decoration.text}</div>)
        });

        let viewDetailsButton = <img src={informationIcon} onClick={(event) => { event.stopPropagation(); this.viewDetails([record.uuid])}} className="detailIcon" alt='icon'/>
        
        record.assessmentTypeDecorated = (
          <>
            {record.assessmentName}
            {additionalType && <br />}
            {additionalType && additionalType}
            {viewDetailsButton}
            {this.getHTMLReportsButton(record)}
          </>
        );
      }
      record.decoratedAssessmentTypeText = decoratedAssessmentTypeText;

      let r = [];
      if (record.userEnnea || record.userTriType || record.userInstinct) {
        r.push(record.userEnnea);
        r.push(record.userTriType);
        r.push(record.userInstinct);
      }
      record.results = r.join(' ');

      if (r[2] === null) {
        record.results = ""
      }

      let c = [];
      c.push(record.clientName)
      c.push(record.clientSurname)
      if ((record.clientName) && (record.clientSurname))
        record.fullname = c.join(' ');

      let cc = [];
      cc.push(record.coachName)
      cc.push(record.coachSurname)

      record.coachName = cc.join(' ');

      record.trackingStatus = this.generateStatus(record);
      
      if(record.otherData){
        otherDataExists = true;
      }

      if (this.props.scoMode==='given') {
        record.uuid = this.makeSCO_UUID(record)
      }

      let newInfoTile = record.fullname;
      record.infoTile = this.makeInfoTile(record)
      record.infoTileSearchableText = record.fullname + " "+ record.clientEmail;
      record.newInfoTile = newInfoTile;

      record.mobileInfoTile = this.mobileInfoTile(record)
    }
    if (otherDataExists) {
      this.setState({
        otherDataExists:true
      })
    }
  }

  makeSCO_UUID = (record) => {
    return(record.uuid+':'+record.coachUUID);
  }

  parseSCO_UUID = (uuid) => {
    var parts = uuid.split(':');
    return({
      uuid: parts[0],
      coachUUID: parts[1]
    })
  }


  showClientResults = async (event, selectedToken) => {
    const { allClients } = this.state;
    var guest = allClients.find(({ userToken }) => userToken === selectedToken[0]);
    window.location=`/coachportal/clighent/${guest.uuid}`;
  }

  //================== Copy to clipboard function ==========================

  copyCodeToClipboard = (event, selectedToken) => {
    this.copyTextToClipboard(window.location.origin + "/register/token?userToken=" + (selectedToken),this.state.clipboardCancel);
    // find guest assessment
    const { allClients } = this.state;
    var guest = allClients.find(({ userToken }) => userToken === selectedToken[0]);
    // update the invite icon for this assessment
    this.iconUpdate(guest.uuid, true, guest.userInvite);
    // tell backend that assessment link was copied
    aserver.get(`api/v2/tokens/${guest.uuid}/copiedAssessmentLink`);
    // tell coach that assessment link was copied
    if (this.state.devTest) {
      console.log("===============================Copied To Clipboard text ==================================")
      console.log("Copied To Clipboard text", selectedToken)
    }

  }

  openAssignSCOModal = (selectedAssessmentUUIDs)=>{
    if (this.hasRecordFromAnotherCoachCheck(selectedAssessmentUUIDs))
      return;
    this.setState({
      assignSCOModalOpen:true,
      selectedAssessmentUUIDs: selectedAssessmentUUIDs,
    })
  }

  assignSCO = async () => {
    const selectedRecords = this.state.selectedAssessmentUUIDs.map(uuid => this.state.allClients.find(c => c.uuid === uuid)).filter(Boolean);
    const hasNonEnneagramAssessment = selectedRecords.some(r => r.assessmentType !== "Enneagram");
    if (hasNonEnneagramAssessment) {
      try {
        const levelCheck = await aserver.get(`api/v2/coaches/${this.state.coachId}/coachLevelByEmail?email=${encodeURIComponent(this.state.secondaryCoachEmailAddress)}`);
        if (levelCheck.data.found && !levelCheck.data.hasMaturityAccreditation) {
          this.setState({
            assignSCOModalOpen: false,
            scoLevelWarningModal: true,
          });
          return;
        }
      } catch (e) {
        // level check failed, proceed anyway
      }
    }
    this.confirmAssignSCO();
  }

  confirmAssignSCO = async () => {
    this.setState({ assignSCOModalOpen: false, scoLevelWarningModal: false, openBackdrop: true });
    let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/assignSCO`, {
      secondaryCoachEmailAddress: this.state.secondaryCoachEmailAddress,
      assessmentUUIDs: this.state.selectedAssessmentUUIDs
    });
    this.setState({ openBackdrop: false });
    if (scoResult.data.success) {
      if (scoResult.data.countOfNewlyGivenSCOs > 0)
        this.props.updateUserProfile({ hasGivenSCOs: true });
      this.openAlertModal("Success", scoResult.data.message);
    } else {
      this.openAlertModal("Please Note", "That email address is not associated with a coach registered on the Aephoria system");
    }
  }

  openRevokeSCOModal = (selectedSCO_UUIDs) => {
    const records = selectedSCO_UUIDs;
    const coachesList = [];
    for (let record of records) {
        let foundCoaches = this.state.allClients.find(({ uuid }) => uuid === record);
        coachesList.push(foundCoaches.coachName);
    }
    const uniqueCoachlist = [...new Set(coachesList)];
    this.setState({
      revokeSCOModal: true,
      revokeSCOProceedDisabled: false,
      selectedSCO_UUIDs: selectedSCO_UUIDs,
      uniqueCoachlist: uniqueCoachlist
    });
  }

  revokeSCO = async () => {
    this.setState({ revokeSCOProceedDisabled: true });
    var records = this.state.selectedSCO_UUIDs.map(uuid=>this.parseSCO_UUID(uuid));
    let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/revokeSCO`, {
      records: records
    });
    if (scoResult.data.success) {
      this.refreshTable()
    } else {
      this.openAlertModal("Failed", `SCO revoking failed: ${scoResult.data.error}`)
    }
  }


  handleAddToTeam = async (uuid, b, c, selectedRecords) => {
    let getTeam = await aserver.get(`api/v2/coaches/${this.state.coachId}/teams`);
    let filteredTeams = getTeam.data.filter(team => !team.scoReceivedFrom);


    if (filteredTeams.length > 0) {
      this.teamsWithReports = getTeam.data
      .filter(team => team.reportRequested || team.isReportAvailable)
      .map(team => team.uuid);
      this.setState({
        items: filteredTeams,
        assessmentModalTitle: 'Add Assessment To Team',
        assessmentModalSubmitFunction: this.saveAssessmentToTeams,
        assessmentModalSubmitCaption: 'Add To Team',
        addProjectModal: true,
        addToTeamSubmitDisabled: false,
        clientId: uuid,
        guestUuids: selectedRecords,
      });
    } else{
      this.openAlertModal("Failed", "Please create a team first")
    }
  }

  saveAssessmentToTeams = async () => {
    this.setState({ addToTeamSubmitDisabled: true });
    const { guestUuids, team, allClients} = this.state;
    let members = guestUuids;
    let teams = team;

    if (this.teamsWithReports.includes(team)) {
      this.openWarningModal("Please note", "You cannot add members to a team for which a report has already been requested or issued. You can make a duplicate of this team, add and edit its members, and then request a new report for the duplicated team.");
      return;
    }

    const selectedAssessments = (allClients || []).filter(c => (members || []).includes(c.guestUUID));
    let existingMembers = [];
    try {
      const teamMembersResponse = await aserver.get(`api/v2/teams/${team}/members`);
      existingMembers = teamMembersResponse.data || [];
    } catch (err) {
      console.log(err);
    }
    const duplicateEmails = utils.findDuplicateTeamMemberEmails(selectedAssessments, existingMembers);
    if (duplicateEmails.length > 0) {
      this.setState({ addToTeamSubmitDisabled: false, addProjectModal: false });
      this.openWarningModal("Please note", utils.duplicateTeamMemberEmailMessage(duplicateEmails));
      return;
    }

    await utils.addTeamMembers(this, teams, members);
    this.setState({
      team: "",
      addProjectModal: false,
    })
  }

  radioButttonChange = (event) => {
    this.setState({ team: event.target.value })
  }

  // ====================  Send Invites Function =====================================
  openPreInviteModal = (uuids) => {
    let listOfCompletedAssessmentNames = []
    let listOfReminderNames = []
    let listOfNotSentInvitesNames = []
    for (let uuid of uuids) {
      let num = uuid
      const result = this.state.allClients.find(({ uuid }) => uuid === num);
      if (result.guestCompletedAt !== "-") {
        listOfCompletedAssessmentNames.push(result.fullname + " completed on: " + result.guestCompletedAt)
      }
      if ((result.userInvite) && (result.guestCompletedAt === "-")) {
        listOfReminderNames.push(result.fullname)
      }
      if ((result.reminded === 0) && (result.guestCompletedAt === "-") && (!result.userInvite)) {
        listOfNotSentInvitesNames.push(result.fullname)
      }
    }
    let isThereAnIssue = (listOfReminderNames.length > 0 || listOfCompletedAssessmentNames.length > 0);
    this.setState({
      noInviteToSend: (listOfReminderNames.length === 0 && listOfNotSentInvitesNames.length === 0),
      clientUUIDS: uuids,
      openPreInviteModal: isThereAnIssue,
      listOfNotSentInvitesNames: listOfNotSentInvitesNames,
      listOfReminderNames: listOfReminderNames,
      listOfCompletedAssessmentNames: listOfCompletedAssessmentNames
    });
    if (!isThereAnIssue) {
      this.openSendInvitesModal(uuids)
    }
  }

  openSendInvitesModal = (uuids) => {
    const { selected } = this.state;
    if (selected === 1) {
      this.setState({
        disableGmail: false
      })
    }
    this.setState({
      openPreInviteModal: false,
      disableModal: true,
      sendReportModal: true,
      clientUUIDS: uuids,
      sendInviteOrReport: true,
      sendReport: false,
      assessmentModalTitle: 'Send Invites',
    })
  }

  alertUserToEmailReady = (message, address, subject, body) => {
    let textBody = <div>{message} <br></br>The body text will be copied to your clipboard.
      Click ok to open the email in your email client, and then paste the body text into that email.
      <br></br>
      <br></br>
      <b>Note:</b> this will only work if your operating system / browser has been configured to open <tt>mailto:</tt> links correctly.
      </div>
      
    this.setState({
      confirmationModal: true,
      confirmationModalText: textBody,
      confirmationHeading: "Email Ready",
      confirmationFunction: (e) => this.confirmation(e),
      mailToAddress: address,
      mailToSubject: subject,
      mailToBody: body,
    })
  }

  confirmation = async (confirmationBoolean) => {
    const { mailToAddress, mailToSubject, mailToBody } = this.state
    if (confirmationBoolean) {
      await this.copyTextToClipboard(mailToBody,true);
      window.open(`mailto:${mailToAddress}?subject=${mailToSubject}&body=${encodeURIComponent(cClipboardPasteMessage)}`);
    }
    this.setState({
      confirmationModal: false,
    })
  }

copyTextToClipboard = async (text, clipboardCancel) => {
    const trimmedText = text
        .split("\n")
        .map(line => line.trimStart())
        .join("\n");

    const blob = new Blob([trimmedText.replace(/\n/g, "<br/>")], { type: "text/html" });
    const data = [new ClipboardItem({
      "text/html": blob,
      "text/plain": new Blob([trimmedText], { type: "text/plain" })
    })];
    await navigator.clipboard.write(data);

    if (!clipboardCancel) {
      this.setState({ clipboardModal: true });
    } else {
      this.toastMessage("Copied to clipboard", "success");
    }
};

  

  iconUpdate = async (clientUUID, userInvite, reminder) => {
    const { allClients } = this.state;
    let findRecord = allClients.find(({ uuid }) => uuid === clientUUID);
    if (userInvite) {
      findRecord.userInvite = true;
    }
    else {
      findRecord.userReport = true;
    }
    if (userInvite && reminder) {
      findRecord.reminded = 1;
    }

    findRecord.trackingStatus = this.generateStatus(findRecord)

  }

  openSendReportModal = (uuids, b, c, d, e, selectedRecord) => {
    const { selected } = this.state;
    if (selected === 1) {
      this.setState({
        disableGmail: false
      })
    }
    this.openCommonReportModal(uuids, b, c, d, e, selectedRecord,
      {
        assessmentModalTitle: 'Send Reports',
        id: selectedRecord,
        sendInviteOrReport: false,
        sendReport: true,
        sendReportModal: true,
        coachEmailAddress: localStorage.getItem("coachEmailAddress"),
      }
    )
  }

  handleChecked = (event) => {
    let newArray = [...this.state.reports, event.target.id];
    if (this.state.reports.includes(event.target.id)) {
      newArray = newArray.filter(report => report !== event.target.id);
    }
    this.setState({
      reports: newArray
    });
  }

  frame = () => {
    let interval = setInterval(() => {
      var percentage = (this.state.completedCount / this.state.selected) * 100
      this.setState({
        completed: percentage.toFixed()
      })
      if (percentage === 100) {
        this.setState({
          completed: 0,
          completedCount: 1,
          showProgressBar: false
        })
        clearInterval(interval)
      }
    }, 100)
  }

  send = async (serverSend) => {
    const { reports, clientUUIDS, coachEmailAddress, allClients, impersonator, sendInviteOrReport, selected } = this.state;
    let completedCounter = 1;
    let text = sendInviteOrReport ? "invite" : "report";
    this.closeModal()
    if (selected > 1) {
      this.frame()
      this.setState({
        showProgressBar: true
      })
    }
    this.setState({
      openBackdrop: true
    })
    if (serverSend) {
      this.toastMessage("Sending email...", "success")
    } else {
      this.toastMessage("Generating email...", "success")
    }

    let data = {
      reports: reports,
      destinationEmailAddress: impersonator ==="false" ? null : coachEmailAddress,
      useClientEmailAddress: impersonator ==="false",
    };

    let failureMessages = [];
    let SuccessMessage = [];
    for (let Uuid of clientUUIDS) {
      let reminder = false;
      if (sendInviteOrReport) {
        let assessment = allClients.find(({ uuid }) => uuid === Uuid)
        if (assessment.userCompletion === 'complete') {
          continue;
        }
        reminder = assessment.userInvite;
      }
      let sendAPI = sendInviteOrReport ? await aserver.get(`api/v2/tokens/${Uuid}/sendinvite?serverSend=${serverSend}`) : await aserver.post(`api/v3/tokens/${Uuid}/reports?serverSend=${serverSend}`, data);
      if (!serverSend) {
        this.setState({
          showToast: false,
          openBackdrop: false
        });
        this.iconUpdate(Uuid, sendInviteOrReport, reminder);
        this.alertUserToEmailReady(`The ${text} email has been generated.`, sendAPI.data.emailAddress, sendAPI.data.subject, sendAPI.data.body);
      } else {
        if (!sendAPI.data.sent) {
          let findClient = allClients.find(({ uuid }) => uuid === Uuid);
          failureMessages.push(`${findClient.fullname} send failed with ${sendAPI.data.error}.`);
        } else {
          this.setState({
            completedCount: completedCounter++
          })
          this.iconUpdate(Uuid, sendInviteOrReport, reminder);
          SuccessMessage.push(`Client send success`)
        }
      }
    }
    if (failureMessages.length > 0) {
      this.setState({
        showToast: false,
        openBackdrop: false,
        successModalText: `${SuccessMessage.length} of ${clientUUIDS.length} ${text} emails sent successfully.`,
        failModalText: failureMessages,
      });
      this.openAlertModal("Failed")
    }
    if (SuccessMessage.length > 0 && failureMessages.length === 0) {
      this.toastMessage(`${SuccessMessage.length} ${text} emails sent successfully.`, "success")
      this.closeModal()
    }
  }

  sendFunction = (serverSend) => {
    const { reports, coachEmailAddress, sendReport } = this.state;
    if ((sendReport) && (reports.length === 0)) {
      this.toastMessage("Please select a report", "danger")
      return;
    }
    if (sendReport && reports.length > 0 && coachEmailAddress.length > 0) {
      this.send(serverSend)
    } else if (!sendReport) {
      this.send(serverSend)
    } else {
      if (coachEmailAddress.length === 0) {
        this.toastMessage("Please enter email address", "danger")
      }
    }

  }

  //============================================ functions to open download report modal and download functions ================================

  showAllowedReportsForAssessments = (assessments) => {
    let groups = {
      availableNow: { groupHeading: 'Available now', reports: [] },
      waitingForMarking: { groupHeading: 'Waiting for marking', reports: [] },
      notApplicable: { groupHeading: 'Not applicable to this assessment', reports: [] },
    };
    if (this.state.selected !== 1) {
      groups.notApplicable.groupHeading = 'Not applicable for every assessment'
    }

    for (let assessment of assessments) {
      if (assessment.userCompletion === "complete" && (assessment.assessmentType === "Enneagram")) {

        groups.notApplicable.reports.push('imf');
        groups.notApplicable.reports.push('foundation');
        groups.notApplicable.reports.push('extended');
        groups.notApplicable.reports.push('imfCoG');
        groups.notApplicable.reports.push('combinedClientOverview');
        //groups.notApplicable.reports.push('combinedCoachOverview');
      }

      if (assessment.assessmentType === "IMf" && assessment.marked === true) {

        groups.notApplicable.reports.push('basic');
        groups.notApplicable.reports.push('foundation');
        groups.notApplicable.reports.push('extended');
        groups.notApplicable.reports.push('clientSummary');
        groups.notApplicable.reports.push('enneaOverview');
        groups.notApplicable.reports.push('combinedClientOverview');
        //groups.notApplicable.reports.push('combinedCoachOverview');
      }

      if (assessment.assessmentType === "IMf" && assessment.marked === false) {
        groups.waitingForMarking.reports.push('imf');
        groups.waitingForMarking.reports.push('imfCoG');

        groups.notApplicable.reports.push('basic');
        groups.notApplicable.reports.push('foundation');
        groups.notApplicable.reports.push('extended');
        groups.notApplicable.reports.push('clientSummary');
        groups.notApplicable.reports.push('enneaOverview');
        groups.notApplicable.reports.push('combinedClientOverview');
        //groups.notApplicable.reports.push('combinedCoachOverview');
      }

      if (assessment.assessmentType === "Full" && assessment.marked === false && assessment.userEnnea !== null) {
        groups.waitingForMarking.reports.push('imf');
        groups.waitingForMarking.reports.push('foundation');
        groups.waitingForMarking.reports.push('extended');
        groups.waitingForMarking.reports.push('imfCoG');
        groups.waitingForMarking.reports.push('combinedClientOverview');
        //groups.waitingForMarking.reports.push('combinedCoachOverview');
      }
    }

    for (var reports in reportCodesToNames) {
      if (reportCodesToNames.hasOwnProperty(reports)) {
        groups.availableNow.reports.push(reports);
      }
    }

    for (const key of Object.keys(groups)) {
      groups[key].reports = groups[key].reports.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) === index;
      });
    }

    groups.availableNow.reports = groups.availableNow.reports.filter(report => !groups.notApplicable.reports.includes(report))
    groups.availableNow.reports = groups.availableNow.reports.filter(report => !groups.waitingForMarking.reports.includes(report))

    return groups

  }

  openCommonReportModal = (uuids, b, c, d, e, selectedRecord, newState) => {
    const { allClients } = this.state;
    let selectedRecordsArray = []
    let notCompleted = 0
    for (let uuid of uuids) {
      let num = uuid
      const result = allClients.find(({ uuid }) => uuid === num);
      selectedRecordsArray.push(result)
      if (uuids.length === 1) {
        this.setState({
          downloadReportSubHeading: `Downloading reports for ${result.fullname} `,
          clientName: result.fullname,
        })
      } else {
        this.setState({
          downloadReportSubHeading: `Downloading reports for ${uuids.length} selected clients`
        })
      }
      if (result.userCompletion === null) {
        notCompleted++
        this.openAlertModal("Please Note", "Not all selected assessments are completed - please modify selection to include only completed assessments.")
      }

    }
    if (notCompleted === 0) {
      newState.clientUUIDS = uuids;
      newState.assessmentInfo = selectedRecordsArray;
      this.setState(newState);
    }
  }

  openDownloadReport = (uuids, b, c, d, e, selectedRecord) => {
    this.openCommonReportModal(uuids, b, c, d, e, selectedRecord,
      {
        downloadReportModal: true,
        downloadReportModalTitle: "Download Reports",
      }
    )

  }

  updateReportStatus = (report, status, color) => {
    let stateUpdate = {}
    stateUpdate['status' + report] = status;
    stateUpdate['statuscolor' + report] = color;
    this.setState(stateUpdate);
  }

  emptyDownloadStatus = () => {
    const { reports } = this.state;
    for (let report of reports) {
      this.updateReportStatus(report, '')
    }
  }

  stopDownload = () => {
    this.setState({
      stopDownload: true,
      stopButtonTitle: "Stopping...",
    });
  };

  downloadReports = async () => {
    const { allClients, reports, clientUUIDS } = this.state;
    if (reports.length > 0) {
      this.setState({
        openBackdrop: true,
        downloadReportModalTitle: "Downloading Reports",
        stopDownload: false,
        stopButtonTitle: "Stop Download",
      });
      let count = 0;
      let failedDownloads = []
      for (let UUID of clientUUIDS) {
        this.setState({
          disableCheckBox: true,
          completedCount: count++,
          downloadReportSubHeading: clientUUIDS.length > 1 ? `Downloading reports for ${count} of ${this.state.clientUUIDS.length} clients` : `Downloading reports for ${this.state.clientName}`
        });
        for (let report of reports) {
          if (this.state.stopDownload) {
            this.setState({
              downloadReportModalTitle: "Download Stopped",
              stopDownload: false,
              downloadReportSubHeading: ""
            });
            return;
          }
          this.updateReportStatus(report, "Downloading...", "#99c93d");
          let findClient = allClients.find(({ uuid }) => uuid === UUID);
          let reportCode = report.split('.')[0];
          let reportLanguage = '';
          if (report.includes('.'))
            reportLanguage = ' ('+utils.capitalize(report.split('.')[1])+')';
          let download = await aserver.download(
            aserver.generateReportDownloadURL(report, this.state.coachId, UUID),
            `${findClient.fullname} ${reportCodesToNames[reportCode]}${reportLanguage}.pdf`
          );
          if (download.status !== 200) {
            this.updateReportStatus(report, "Failed:" + download.data.error.info, "red");
            failedDownloads.push(reportCodesToNames[report])
          } 
          else{
            this.updateReportStatus(report, "Done!", "green");
            this.emptyDownloadStatus();
          }
        }
      }
      if (clientUUIDS.length === 1) {
        this.setState({
          downloadReportSubHeading: `Downloaded reports for ${this.state.clientName} `
        })
      }
      else {
        this.setState({
          downloadReportSubHeading: `Downloaded reports for ${this.state.completedCount + 1} of ${this.state.clientUUIDS.length} clients`
        })
      }
      if(failedDownloads.length === 0)
        this.setState({
          downloadReportModalTitle: "Download Complete",
          showDoneTitle: true,
        });
      else
       this.setState({
        downloadReportModal:false,
        showFailedDownloadModal: true,
        failedDownloads: failedDownloads,
       })
    } else {
      this.toastMessage("Please select a report to download", "danger");
    }
  };

  openWrapUpModal = (guestUUIDS) => {
    let wrappedArray = []
    let hasWrapped = false;
    let hasUnwrapped = false;

    for (let guestUUID of guestUUIDS) {
        let checkedIfWrapped = this.state.allClients.find(({ uuid }) => uuid === guestUUID);
        wrappedArray.push(checkedIfWrapped.coachWrappedUp);

        if (checkedIfWrapped.coachWrappedUp) {
            hasWrapped = true;
        } else {
            hasUnwrapped = true;
        }
    }

    if (hasWrapped && hasUnwrapped) {
      this.openWarningModal("Warning","The selection contains both previously wrapped up and unwrapped up assessments. Please change the selection to include only all wrapped up or all unwrapped up assessments.");
        return; 
    }

    const confirmationMessage = hasUnwrapped ? 
        "The selected assessment(s) will be marked as wrapped up, which means they will not be included in the dashboard to-do summaries." : 
        "The selected assessment(s) will no longer be marked as wrapped up, which means they will be included again in the dashboard to-do summaries.";

    this.setState({
        confirmationModal: true,
        confirmationModalText: confirmationMessage,
        confirmationHeading: "Confirmation",
        confirmationFunction: () => this.wrapUpAssessment(guestUUIDS),
    });
  }

  wrapUpAssessment = async (guestUUIDS) => {
    if (this.hasRecordFromAnotherCoachCheck(guestUUIDS))
      return;
    const { allClients } = this.state;
    let failureMessages = [];
    let SuccessMessage = [];
    for (let guestUUID of guestUUIDS) {
      let checkedIfWrapped = allClients.find(({ uuid }) => uuid === guestUUID);
      let wrap = await aserver.put(`api/v2/tokens/${guestUUID}`, {
        coachWrappedUp: checkedIfWrapped.coachWrappedUp === 1 ? false : true
      });
      if (wrap.status !== 200) {
        let findClient = allClients.find(({ uuid }) => uuid === guestUUID);
        failureMessages.push(`${findClient.fullname} wrapped up failed.`);
      } else {
        SuccessMessage.push(`Client closed successfully`)
      }
    }
    if (failureMessages.length > 0) {
      this.setState({
        showToast: false,
        openBackdrop: false,
        failModalText: failureMessages,
      });
      this.openAlertModal("Failed")
    }
    if (SuccessMessage.length > 0) {
      this.refreshTable()
    }
  }

  openWarningModal =  (title, message) =>{
    this.setState({
      warningTitle: title,
      warningMessage:message,
      openWarningModal:true,
    })    
  }

  openAlertModal = (title, message, boolean) => {
    this.setState({
      alertModalTitle: title,
      alertMessage: message,
      openAlertModal: true,
      refresh:boolean
    })
  }

  generateAutoSendCheckboxes(assessmentType) {
    const imfCheckboxes = (
      <div> 
        <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.imf === 'imf'} name="imf" id="imf" value="imf" />
        <label className="sendReportLabel" htmlFor="imf">{reportCodesToNames.imf}</label>
        <br></br>
        <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.imfCoG === 'imfCoG'} name="imfCoG" id="imfCoG" value="imfCoG" />
        <label className="sendReportLabel" htmlFor="imfCoG">{reportCodesToNames.imfCoG}</label>
        <br></br>
      </div>
    );
  
    const enneagramCheckboxes = (
      <div>
        <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.clientSummary === 'clientSummary'} name="clientSummary" id="clientSummary" value="clientSummary" />                      
        <label className="sendReportLabel" htmlFor="clientSummary">{reportCodesToNames.clientSummary}</label>
        <br></br>
        <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.basic === 'basic'} name="basic" id="basic" value="basic" />
        <label className="sendReportLabel" htmlFor="basic">{reportCodesToNames.basic}</label>
        <br></br>
      </div>
    );

    const fullCheckboxes = (
      <div>
          <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.foundation === 'foundation'} name="foundation" id="foundation" value="foundation" />
          <label className="sendReportLabel" htmlFor="foundation">{reportCodesToNames.foundation}</label>
          <br></br>
          <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.extended === 'extended'} name="extended" id="extended" value="extended" />
          <label className="sendReportLabel" htmlFor="extended">{reportCodesToNames.extended}</label>
          <br></br>
      </div>
    )
  
    if (assessmentType === 'EIT' || assessmentType === "IMf") {
      return (
        <div>
          <span className="delineatedHeading">Auto-send reports after marking</span>
          <br></br>
          {this.state.showOtherCheckboxes?<>{imfCheckboxes}</>:<span className="viewModalSpan">Assessment(s) have already been marked.</span>}
        </div>
      );
    } else if (assessmentType === 'full'||assessmentType === "Full") {
      return (
        <div>
          <span>Auto-send reports on completion:</span>
          <br></br>          
          {this.state.showEnneagramCheckboxes?<>{enneagramCheckboxes}</>:<span className="viewModalSpan">Assessment(s) have already been completed.</span>}
          <br></br>
          <span className="delineatedHeading">Auto-send reports after marking</span>
          <br></br>
          {this.state.showOtherCheckboxes?<>{imfCheckboxes}{fullCheckboxes}</>:<span className="viewModalSpan">Assessment(s) have already been marked.</span>}
        </div>
      );
    } else if (assessmentType === 'ennea'||assessmentType === "Enneagram") {
      return (
        <div>
          <span>Auto-send reports on completion:</span>
          <br></br>          
          {this.state.showEnneagramCheckboxes?<>{enneagramCheckboxes}</>:<span className="viewModalSpan">Assessment(s) have already been completed.</span>}
        </div>
      );
    } else if(assessmentType ==="showText") {
        return (<p>To change auto-send options for assessments, select only assessments of the same kind.</p>)
    }
      else{
      return null;
    }
  }
  

  openPreviewModal = async () => {
    // sendInviteOrReport = true if sending invite, false if sending report
    const { clientUUIDS, sendInviteOrReport, reports, impersonator, coachEmailAddress, allClients } = this.state;
    if ((!sendInviteOrReport) && (reports.length === 0)) {
      this.toastMessage("Please select a report", "danger")
      return;
    }
    this.setState({
      sendReportModal: false,
      previewModal: true,
    });
    var data = {
      reports: reports,
      destinationEmailAddress: impersonator ==="false" ? null : coachEmailAddress,
      useClientEmailAddress: impersonator === "false",
    };
    var previewTextArray = [];
    var failureMessages = [];
    var previewCounts = {
      reports: 0,
      enneagramInvite: 0,
      imfInvite: 0,
      fullInvite: 0
    }
    for (let Uuid of clientUUIDS) {
      // get client that we're sending this email for:
      var client = allClients.find(({ uuid }) => uuid === Uuid)
      // get type of email we're sending for this client
      var typeOfEmail = 'reports'; // assume type is reports
      if (sendInviteOrReport) {
        // no, type is invite, let's see what kind:
        typeOfEmail = client.assessmentType.toLowerCase() + 'Invite';
      }
      previewCounts[typeOfEmail] = previewCounts[typeOfEmail] + 1;
      if (previewCounts[typeOfEmail] > 1) {
        // we already have a preview of this kind of email, so continue to the next email
        continue;
      }
      let sendAPI = sendInviteOrReport ?
        await aserver.get(`api/v2/tokens/${Uuid}/sendinvite?serverSend=false}&forPreview=true`) :
        await aserver.post(`api/v3/tokens/${Uuid}/reports?serverSend=false&forPreview=true`, data);
      if (sendAPI.status === 400) {
        failureMessages.push(sendAPI.data.error.info)
        continue;
      }
      var heading = (typeOfEmail === 'reports') ?
        `Send Reports for ${client.fullname}` :
        `${assessmentTypes[client.assessmentType]} Invite for ${client.fullname}`;
      var previewText = sendAPI.data.body.replace(/(\r\n|\n|\r)/g, "<br />");
      previewTextArray.push(`<b>${heading}</b> <br><br> ${previewText}`);
    }

    // set preview explanation
    var explanation;
    var check = 'Please check to ensure the text is correct regarding client name and other details. ';
    var scroll = 'Scroll down to check the different invites. ';
    if (clientUUIDS.length === 1) {
      // 1) one email with one preview
      explanation = 'The email is previewed below. ' +
        check +
        'Once you approve the preview, the email will be sent';
    } else {
      // 2) more than one email
      if (previewTextArray.length === clientUUIDS.length) {
        //2.1) with as many emails as there are previews
        explanation = 'The emails are previewed below. ' +
          check + scroll +
          'Once you approve the preview, the emails will be sent';
      } else {
        //2.2) with more emails than previews
        // (either with one preview or more than one)
        explanation = (previewTextArray.length === 1 ? 'A selected email is previewed below. ' : 'A selection of emails are previewed below. ') +
          check + (previewTextArray.length === 1 ? '' : scroll) +
          'Note, this is just a representative selection of the emails to be sent. Names and links in the other emails are automatically updated. ' +
          'Once you approve the preview, the emails for all the clients will be sent';
      }
    }
    this.setState({ previewExplanation: explanation });

    document.getElementById("previewTextArea").innerHTML += previewTextArray.join('<br><br><br>');

    if (failureMessages.length > 0) {
      this.setState({
        failModalText: failureMessages,
      })
      this.openAlertModal("Failed")
    }
  }

  hasOnlyDuplicates = (array) => {
    if (array.length <= 1) {
        return true; 
    }
    const uniqueValues = new Set(array);
    return uniqueValues.size === 1;
   }

edit = (uuids, b, c, d, clientUUID) => {
    
    if (this.hasRecordFromAnotherCoachCheck(uuids))
      return;

    const { allClients } = this.state;
    
    const extractProperties = (uuids, property) => {
      return uuids.map(UUID => allClients.find(({ uuid }) => uuid === UUID)[property]);
    };

    const areAllEqual = array => array.every(value => value === array[0]);
    
    const namesArray = extractProperties(uuids, 'clientName');
    const surnamesArray = extractProperties(uuids, 'clientSurname');
    const emailsArray = extractProperties(uuids, 'clientEmail');
    const companyArray = extractProperties(uuids, 'clientCompany');
    const otherDataArray = extractProperties(uuids, 'otherData');
    const projectNames = extractProperties(uuids, 'userCoach');
    const assessmentLanguageArray = extractProperties(uuids, 'assessmentLanguage');
    const assessment = extractProperties(uuids, 'assessmentType');
    const reportsCoachWantSend = extractProperties(uuids, 'reportsToAutoSend');
    const completedAssessments = extractProperties(uuids, 'userCompletion')
    const markedAssessments = extractProperties (uuids, 'marked')
    let reportNames = new Set();

    for (let i = 0; i < reportsCoachWantSend.length; i++) {
        if (reportsCoachWantSend[i]) {
            const individualReports = reportsCoachWantSend[i].split(',');
            individualReports.forEach(reportName => {
                reportNames.add(reportName);
            });
        }
    }
    const stateToUpdate = {};
    
    reportNames.forEach(reportName => {
        stateToUpdate[reportName] = reportName;
    });

    const tokenTypeArray = extractProperties(uuids, 'tokenType');

    const projectName = areAllEqual(projectNames) ?  String(projectNames[0] || ''): '';
    const clientName = areAllEqual(namesArray) ? namesArray[0] : '';
    const clientSurname = areAllEqual(surnamesArray) ? surnamesArray[0] : '';
    const clientEmail = areAllEqual(emailsArray) ? emailsArray[0] : '';
    const clientCompany = areAllEqual(companyArray) ? companyArray[0] : '';
    const clientOther = areAllEqual(otherDataArray) ? otherDataArray[0] : '';
    const assessmentLanguage = areAllEqual(assessmentLanguageArray) ? assessmentLanguageArray[0].toLowerCase() : '';
    const assessmentCheck = areAllEqual(assessment) ? assessment[0] : 'showText';
    const tokenTypeEdit = areAllEqual(tokenTypeArray) ? tokenTypeArray[0].toLowerCase() : '';
    const showEnneagramCheckboxes = areAllEqual(completedAssessments)&&completedAssessments[0]!=="complete"?true : false;
    const showOtherCheckboxes = areAllEqual(markedAssessments) && !markedAssessments[0]?  true:false;
    const clientUUIDArray = uuids.map(UUID => allClients.find(({ uuid }) => uuid === UUID).clientUUID);
    const reportsBeingSentAreTheSame = areAllEqual(reportsCoachWantSend) ? true : false
    const isAssessmentComplete = completedAssessments.includes("complete");

    this.setState({
      editModal: true,
      clientUUIDS: uuids,
      project: projectName,
      name: clientName,
      surname: clientSurname,
      email: clientEmail,
      company: clientCompany,
      other: clientOther,
      language: assessmentLanguage,
      tokenType: tokenTypeEdit,
      clientUUIDArray: clientUUIDArray,
      disableInputs: this.hasOnlyDuplicates(clientUUIDArray),
      ShowEditAssessments: assessmentCheck,
      ...stateToUpdate,
      isThereMultipleReports: reportsCoachWantSend.length>1 && assessmentCheck!=="showText" && !reportsBeingSentAreTheSame?true:false,
      showEnneagramCheckboxes:showEnneagramCheckboxes,
      showOtherCheckboxes: showOtherCheckboxes,
      blockFields: this.state.impersonator !== "true"&&isAssessmentComplete,
      // hideNameSurnameFields: clientUUIDArray.length > 1,
    });
    this.populateProjects(projectName)

}


  hasRecordFromAnotherCoachCheck = (uuids)=>{
    for (let UUID of uuids) {
      let client = this.state.allClients.find(({ uuid }) => uuid === UUID);
      if (client && client.fromAnotherCoach) {
        this.openAlertModal("Please Note", "Your selection includes assessments that were given to you by another coach. Please amend your selection and try again.")
        return true; 
      }
    }
    return false; 
  }

  languageDropdown = (e) => {
    this.setState({ language: e.target.value });
  }

  saveEditedChanges = async () => {
    const { clientUUIDS, project, allClients, language, tokenType, name, surname, email, company, other, clientUUIDArray,showInvalidEmailAddressText} = this.state;
    if (email && !utils.validateEmail(email)) {
      this.toastMessage("Please provide a valid email address.", "danger");
      return
    }
    const updateClient = async (clientUUID) => {
        let update = await aserver.put(`api/v2/clients/${clientUUID}`, {
            name,
            surname,
            email,
            company,
            otherData: other
        });
        if (update.status !== 200) {
            this.openAlertModal("Failed", update.data.error.info);
            return false;
        }
          for (let i = 0; i < allClients.length; i++) {
            if (allClients[i].clientUUID === clientUUID) {
                allClients[i].fullname = name + " " + surname;
                allClients[i].clientEmail = email;
                allClients[i].clientCompany = company;
                allClients[i].otherData = other;
                allClients[i].infoTile = this.makeInfoTile(allClients[i]);
            }
          }
        return true;
    };

    const updateAssessments = async () => {
        let data = {};
        if (language) data.assessmentLanguage = language;
        if (project) data.userCoach = project;
        //if (tokenType) data.tokenType = tokenType; //#958
        if (this.state.autoSendReportsChanged)data.reportsToAutoSend = this.generateAutoSendReports()

        let userInformation = [];

        for (let UUID of clientUUIDS) {
            let assessment = allClients.find(({ uuid }) => uuid === UUID);
            let updateAssessment = await aserver.put(`api/v2/tokens/${UUID}`, data);

            if (updateAssessment.status !== 200) {
                userInformation.push("Update failed for " + assessment.clientName);
            } else {
                let findClient = allClients.findIndex((obj => obj.uuid === UUID));
                if (project) allClients[findClient].userCoach = project;
                if (language) allClients[findClient].abbreviatedAssessmentLanguage = this.abbreviateLanguage(language);
                if (language) allClients[findClient].assessmentLanguage = language
                //if (tokenType) allClients[findClient].tokenType = tokenType; //#958
                if (this.state.autoSendReportsChanged) allClients[findClient].reportsToAutoSend = this.generateAutoSendReports()
            }
        }

        if (userInformation.length > 0) {
            this.setState({
                editModalArray: userInformation,
                openEditModal: true,
                editModal: false,
            });
        } else {
            this.closeModal();
        }
    };

    if (this.hasOnlyDuplicates(clientUUIDArray)) {
        for (let clientUUID of clientUUIDArray) {
            let clientUpdate = await updateClient(clientUUID);
            if (clientUpdate) {
                await updateAssessments();
            }
        }
    } else {
        await updateAssessments();
    }
  };

  openMakeHybridModal =(uuids)=>{
    const [assessment1, assessment2] = uuids;
    let assessmentsToHybridize = []
    let getAssessment1 = this.state.allClients.find(({ uuid }) => uuid === assessment1)
    let getAssessment2 = this.state.allClients.find(({ uuid }) => uuid === assessment2)
    let isClientTheSame = getAssessment1.fullname === getAssessment2.fullname
    let isAssessmentsCompleted = getAssessment1.userCompletion && getAssessment2.userCompletion
    let isAssessmentTheSame =
    (["Enneagram", "IMf"].includes(getAssessment1.assessmentType) &&
      getAssessment1.assessmentType === getAssessment2.assessmentType);
    // only block when NEITHER assessment is directly owned - if the coach owns one of the
    // two, the client is already theirs and the other side is just shared in via SCO
    let isFromAnotherCoach = getAssessment1.fromAnotherCoach && getAssessment2.fromAnotherCoach;

    if(!isClientTheSame){
      this.openAlertModal("Please note", "You are not allowed to combine 2 different clients.")
    }else if(isFromAnotherCoach){
      this.openAlertModal("Please note", "This assessment was shared with you via Secondary Coach Ownership. Please contact the primary coach to combine these assessments and share the result with you.")
    }else if(!isAssessmentsCompleted){
      this.openAlertModal("Please note", "Assessments are not complete.")
    } else if (isAssessmentTheSame){
      this.openAlertModal("Please note", "The assessments you want to combine are the same.")
    }else{

      let latestCompletedAssessment = null;
      if (getAssessment1.guestCompletedAt > getAssessment2.guestCompletedAt) {
        latestCompletedAssessment = getAssessment1;
      } else {
        latestCompletedAssessment = getAssessment2;
      }

      assessmentsToHybridize.push(getAssessment1,getAssessment2)
      for (const a of [getAssessment1,getAssessment2])
        a.assessmentTypeDisplay = utils.assessmentCodeToName(a.assessmentTypeUntouched)
      this.setState({
        openMakeHybridModal: true,
        assessmentsToHybridize: assessmentsToHybridize,
        hybridizeName: getAssessment1.fullname,
        chooseBIO: latestCompletedAssessment.uuid,
      })
    }
  }

  hybridize = async() =>{   
    
      const {selectedAssessments, chooseBIO} = this.state
      let hybridize = await aserver.get(`api/v3/hybridise/${chooseBIO}/${selectedAssessments.chooseEnneagram}/${selectedAssessments.chooseIMf}`); 
      if(hybridize.status === 200){
       this.setState({
         openMakeHybridModal:false,
         chooseBIO:null,
         selectedAssessments: {
           chooseEnneagram: null,
           chooseIMf: null,
         },
       })
       aserver.convertUTCToLocal(hybridize.data.guest, 'completedAt', true);
       this.openAlertModal("Success",`The combined assessment has been generated - you will find it on the table with completion date ${hybridize.data.guest.completedAt} and with created date today`,true)
      }else{
       this.openAlertModal("Failed", hybridize.data.error)
      }
  }

  isSelected = (uuid, assessmentType) => {
    return this.state.selectedAssessments[assessmentType] === uuid;
  };
  
  handleCheckboxChange = (uuid, assessmentType) => {
    const selectedAssessments = { ...this.state.selectedAssessments };
    selectedAssessments[assessmentType] = uuid;
    let enneaAndImfSelected = selectedAssessments.chooseEnneagram && selectedAssessments.chooseIMf
    this.setState({ 
      selectedAssessments,
      disableProccedButton: enneaAndImfSelected?false:true
    });
  };

  populateProjects =(value)=>{
    const coachProjects = Array.from(
      new Set(
        this.state.allClients
          .map(client => client.userCoach)
          .filter(userCoach => userCoach && userCoach.trim() !== "")
      )
    );
    this.setState({
      coachProjects:coachProjects,
      projectName: value
    });
  }

  // =======================================Client page functions start =================================================================

  openClientModal = (value) => {
    this.populateProjects()
    if(value.length>=1){
      this.openAlertModal("Warning", "To add a new client, please deselect any currently selected assessment.");
      return
    }
    this.blankCoach();
    this.setState({
      coachModalTitle: 'Add Client & Assessment',
      coachModalSubmitFunction: this.addClient,
      coachModalSubmitCaption: 'Add Client',
      modalIsOpen: true,
      disableInputs: true,
      showEnneagramCheckboxes:true,
      showOtherCheckboxes:true,
    });
  }

  addClient = async (event) => {
    const { name, surname, email, company, coachId, selectValue, tokenType, allClients, project, language, other , importResultsCheck,showInvalidEmailAddressText} = this.state;
    event.preventDefault();
    let areDetailsFilled = email && name && surname
    if(!areDetailsFilled){
      this.toastMessage("Please fill in all the client details (name, surname, and email).", "danger")
      return;
    }   
    if(showInvalidEmailAddressText){
      this.toastMessage("Please provide a valid email address.", "danger")
      return;
    }
    let existingClient = allClients.find(({ clientEmail }) => clientEmail.toLowerCase() === this.state.email.toLowerCase());
    if ((existingClient)&&(!existingClient.fromAnotherCoach)) {
      this.toastMessage("You have already added this client. Please add an assessment to the existing client.", "danger")
      return;
    }
    if ((!importResultsCheck)&&(!selectValue)) {
      this.toastMessage('Please select an Assessment', "danger")
      return;
    }
    if (!importResultsCheck) {
      this.setState({
          addClientButton: true
      })
      let addedClientResponse = await aserver.post(`api/v2/coaches/${coachId}/clients`,      {
        name: name,
        surname: surname,
        email: email,
        company: company,
        otherData: other,
      });
      if(addedClientResponse.status === 400){
        this.setState({modalIsOpen: false})
        this.openAlertModal("Failed", addedClientResponse.data.error.info);
        return
      }
      else if (addedClientResponse.status !== 200) {
        this.openAlertModal("Failed", "There was an unexpected error.");
        return;
      } 
      else {
      this.setState({
          addClientButton: true
        })
        let addedAssessmentResponse = await aserver.post(`api/v2/clients/${addedClientResponse.data.uuid}/tokens`,  {
          assessmentType: selectValue,
          tokenType: tokenType,
          userCoach: project,
          reportsToAutoSend: this.generateAutoSendReports(),
          assessmentLanguage: language
        });
        if (addedAssessmentResponse.status !==200) {
          this.openAlertModal("Failed", "There was an unexpected error.");
          return;
        } else
           this.refreshTable()
      }
    }else {
      this.importResults(coachId)
    }
  }

  openExistingTokenModal = async (uuid,b,c,d, clientUUID) => {
    const { allClients } = this.state;
    let uuidNumber = uuid.join("");
    let findClient = allClients.find(({ uuid }) => uuid === uuidNumber);
    if ((findClient&&findClient.fromAnotherCoach)) {
      this.openAlertModal("Please note", `This is not an existing client of yours - rather, the assessment was given to you by ${findClient.coachName}.\n Use the 'Add... Add Assesment for New Client' option to add an assessment for ${findClient.clientName} ${findClient.clientSurname}.`);
      return;
    }
    let getInfo = await aserver.get(`api/v2/clients/${clientUUID}/tokens`)

    if (getInfo) {
      this.setState({
        clientListOfAssessments: getInfo.data
      })

      for (let record of getInfo.data) {

        if (record.assessmentType === "ennea") {
          record.assessmentType = "Enneagram"
        }

        if (record.assessmentType === "EIT") {
          record.assessmentType = "IMf"
        }

        if (record.assessmentType === "full") {
          record.assessmentType = "Full"
        }

        aserver.convertUTCToLocal(record, 'createdAt', true);
        aserver.convertUTCToLocal(record, 'completedAt', true);
      }
    }
    this.setState({
      coachModalTitle: `Add assessment to ${findClient.fullname}`,
      coachModalSubmitFunction: this.addExistingToken,
      coachModalSubmitCaption: 'Add Assessment',
      modalIsOpen: true,
      clientUUID: clientUUID,
      showInfo: true,
      showEnneagramCheckboxes:true,
      showOtherCheckboxes:true,
      project: findClient.userCoach,
    });
    this.populateProjects(findClient.userCoach)
  }

  addExistingToken = async () => {
    const { selectValue, tokenType, clientUUID, project, language, importResultsCheck,coachId,showInvalidEmailAddressText } = this.state;
    if (selectValue === "" && !importResultsCheck) {
      this.toastMessage("Please select an assessment", "danger");
      return
    }
    if(importResultsCheck){
      this.importResults(coachId, clientUUID)
    }else{
      this.setState({
        addClientButton:true
      })
      let added = await aserver.post(`api/v2/clients/${clientUUID}/tokens`,
        {
          assessmentType: selectValue,
          tokenType: tokenType,
          userCoach: project,
          reportsToAutoSend: this.generateAutoSendReports(),
          assessmentLanguage: language,
        });
      if (added.status === 200) {
        this.refreshTable()
      }
      else
        this.openAlertModal("Failed", added.data.error.info)
    }
  }

  openBulkAdd = (value) => {
    this.populateProjects()
    if(value.length>=1){
      this.openAlertModal("Warning", "To bulk add assessments, please deselect any currently selected assessment.");
      return
    }
    this.setState({
      coachModalTitle: 'Bulk Add Clients and Assessments',
      coachModalSubmitFunction:()=> this.uploadClientSpreadsheet(false),
      coachModalSubmitCaption: 'Add Clients',
      openBulkModal: true,
      showEnneagramCheckboxes:true,
      showOtherCheckboxes:true,
    })
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({ bulkUploadFile: file });
  }

  uploadClientSpreadsheet = async(duplicatesConfirmedOK) => {
    const { coachId, selectValue, tokenType, project, language,bulkUploadFile } = this.state;
    // eslint-disable-next-line
    if (!selectValue == "" && bulkUploadFile) {
      let uploadURL = `api/v3/coaches/${coachId}/bulkAddClientsTokens/upload`;
      var formData = new FormData();
      formData.append('tokenType', tokenType);
      formData.append('userCoach', project);
      formData.append('reportsToAutoSend', this.generateAutoSendReports())  
      formData.append('assessmentLanguage', language,)
      formData.append('spreadsheet', bulkUploadFile )
      formData.append('assessmentType', selectValue )
      formData.append('project', project )
      if(duplicatesConfirmedOK){
        this.setState({showDuplicateUpload:false})
        formData.append('duplicatesConfirmedOK', true)
      }    

      let upload = await aserver.post(uploadURL, formData);
      if (upload.status === 200 && !upload.data.pleaseConfirm) {
        this.setState({openBulkModal:false})
        this.openAlertModal("Success",upload.data.message, true)
      }else if(upload.data.pleaseConfirm){
        this.setState({
          openBulkModal:false,
          duplicatedGuests: upload.data.duplicatedGuests,
          showDuplicateUpload:duplicatesConfirmedOK?false:true
        })
      } else {
        this.setState({
          bulkUploadFile:"",
          failModalText: upload.data.brokenClients??[]
        })
        this.openWarningModal("Failed", upload.data.error)
        if (this.fileInputRef.current) {
          this.fileInputRef.current.value = null;
        }
      }
    } else {
      this.toastMessage("Please select an assessment and upload spreasheet", "danger")
    }
  }

  onDownload = () => {
    const link = document.createElement("a");
    link.download = `clients_template.xlsx`;
    link.href = process.env.PUBLIC_URL + "/clients_template.xlsx"; //Check if this works with staging link.
    link.click();
  };

  generateAutoSendReports = () => {
    const {clientSummary, basic, imfCoG, imf, foundation,extended} = this.state;
    return [clientSummary, basic, imfCoG, imf,foundation,extended].filter(Boolean).join(",");
  };

  importResultsCheck =(e)=>{
    const { checked } = e.target;
    this.setState({
      importResultsChecked:checked?true:false,
    })
  }

  checkPreferences = (event) =>{
    const { name, checked, value } = event.target;
    this.setState({
        [name]: checked ? value : '',
        autoSendReportsChanged:true
      })
      localStorage.setItem(name, checked ? value : '')
  }

  importResults = async () => {
    
    const { scoreSP, scoreSO, scoreSX, enneaRankingCSV, name, surname, email, project,other,language,company,showInvalidEmailAddressText, selected,clientUUID } = this.state;
    let areDetailsFilled = email && name && surname
    if(selected!==1&&!areDetailsFilled){
      this.toastMessage("Please fill in all the client details (name, surname, and email).", "danger")
      return;
    }   
    if(selected!==1&&showInvalidEmailAddressText){
      this.toastMessage("Please provide a valid email address.", "danger")
      return;
    }
    let postEndpoint = `api/v3/coaches/${this.state.coachId}/newClientImportResults`;
    let payload = {
        name: name,
        surname: surname,
        email: email,
        project: project,
        otherData:other,
        enneaRankingCSV: enneaRankingCSV,
        assessmentLanguage: language,
        company: company,
        scoreSP: scoreSP,
        scoreSO: scoreSO,
        scoreSX: scoreSX
    };

    if (selected) {
        postEndpoint = `api/v3/importResults/${clientUUID}`;
        payload = {
            enneaRankingCSV: enneaRankingCSV,
            scoreSP: scoreSP,
            scoreSO: scoreSO,
            scoreSX: scoreSX,
            project: project,
            assessmentLanguage: language,            
        };
    }

    if (scoreSP !== scoreSO && scoreSP !== scoreSX && scoreSO !== scoreSX) {
        let postResults = await aserver.post(postEndpoint, payload);
        if (postResults.status === 200) {
          this.setState({ importResultsModal: false });
            this.openAlertModal(
                "Success",
                `The results have been imported and there is now a new assessment for ${postResults.data.guest.userName} ${postResults.data.guest.userSurname} - you will find it in the Assessments table with completion and created dates set to today`,
                true
            );
        }else if(postResults.data.error.info){
            this.openWarningModal("Failed", postResults.data.error.info);
        } else {
            this.openWarningModal("Failed", postResults.data.error);
        }
    } else {
        this.openWarningModal(
            "Failed",
            "The instinct scores must be different from each other; there cannot be a tie.",
        );
    }
};

  
  sliderChange = (name) =>(event, value) => {
    this.setState({
      [name]: value
    });
  }

  handleDropdownChange = (e) => {
    this.setState({ 
      selectValue: e.target.value,
      showAutoSend: e.target.value === "EIT"? false:true,
      basic:e.target.value === "EIT"?null:localStorage.getItem("basic") ,
      clientSummary: e.target.value === "EIT"?null:localStorage.getItem("clientSummary"),
      imf:e.target.value === "ennea"?null:localStorage.getItem("imf"),
      imfCoG:e.target.value === "ennea"?null:localStorage.getItem("imfCoG"),
      foundation:e.target.value === "full"?localStorage.getItem("foundation"):null,
      extended:e.target.value === "full"?localStorage.getItem("extended"):null,
      coupleType:e.target.value,
     });
  }

  handleDropdownChangePerson1Pronouns = (e) => {
    this.setState({ person1Pronouns: e.target.value });
  }
  handleDropdownChangePerson2Pronouns = (e) => {
    this.setState({ person2Pronouns: e.target.value });
  }

  handleDropdownChangeTokenType = (e) => {
    this.setState({ tokenType: e.target.value });
  }

  handleDropdownChangePairTokenType = (e) => {
    this.setState({ pairTokenType: e.target.value });
  }

  languageDropdown = (e) => {
    this.setState({ language: e.target.value.toLowerCase() });
  }

  capitalizeFirstLetter=(string) =>{
    if (!string) 
      return string;
    if(string === "Paid")
      return "Billable"

    return string.charAt(0).toUpperCase() + string.slice(1);
}

  closeImportModal = ()=>{
    this.setState({
      importResultsModal:false,
      enneaRankingCSV:"",
      scoreSP:0,
      scoreSO:0,
      scoreSX:0,
    })
  }

  openImportModal = (a,b,c,d, clientUUID)=>{
    this.populateProjects()
    this.setState({
      importResultsModal:true,
      clientUUID
    })
  }

  // Combined/Maturity assessment types require the coach to hold the L2 (Maturity) accreditation.
  assessmentTypeDisabled = ()=>{
    return !this.state.hasMaturityAccreditation
  }

  // =======================================Client page functions end =================================================================

  showStudio = (uuids) => {
    window.open(`/coachportal/reports/${uuids[0]}`, '_blank')
  }

  downloadMailingDetails = async(uuids)=>{
    this.setState({openBackdrop:true});
    this.toastMessage("Downloading...", "success")
    let downloadResponse = await aserver.download(`api/v2/coaches/${this.state.coachId}/downloadMailingDetails`, null, 'POST', {assessmentUUIDs: uuids});
    if(downloadResponse.status !== 200){
      this.openAlertModal("Failed", downloadResponse.data.error.info)
    }
    this.setState({openBackdrop:false});

  }

  getPossibleHTMLReports = (assessment) => {
    let reports = [];
    if (assessment.userInstinct) {
      reports.push({code: 'basic', publishedCode: 'e'});
      if (aserver.ReportLanguages.includes(assessment.assessmentLanguage))
        reports.push({code: 'basic', publishedCode: 'e', language: assessment.assessmentLanguage})
    }
    if (assessment.finalTPR)
      reports.push({code: 'imf', publishedCode: 'm'});
    if (assessment.userInstinct&&assessment.finalTPR) {
      reports.push({code: 'foundation', publishedCode: 'c'});
      reports.push({code: 'extended', publishedCode: 'cp'});
    }
    return(reports);
  }

  getHTMLReportsButton = (assessment) => {
    const possibleHTMLReports = this.getPossibleHTMLReports(assessment);
    if (possibleHTMLReports.length===0)
        return(<></>);
    return(<img src={(possibleHTMLReports.length===1)?reportIcon:reportsIcon} onClick={(event) => { event.stopPropagation(); this.showHTMLReports(assessment.uuid)}} className="showHTMLReports" alt='icon'/>)
  }

  showHTMLReports = (assessmentUUID)=>{
    const { allClients } = this.state;
    const assessment = allClients.find(({ uuid }) => uuid === assessmentUUID);
    const possibleHTMLReports = this.getPossibleHTMLReports(assessment);
    possibleHTMLReports.forEach(i=>i.link=`/coachportal/reports/${i.publishedCode}/${assessmentUUID}`+(i.language?`?language=${i.language}`:''));
    if (possibleHTMLReports.length===1) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: possibleHTMLReports[0].link,
      }).click();
      return;
    }
    this.setState({
      htmlReportsModalContent: <>
        <h2>{assessment.userName} {assessment.userSurname}<br></br>HTML Reports</h2>
        {possibleHTMLReports.map(({code, link, language},index)=>
          <div key={index}>
          <a target="_blank" rel="noreferrer" href={link}>{reportCodesToNames[code]}</a> {language?`(${utils.capitalize(language)})`:''}
          </div>
        )}
        <br></br>
      </>
    });
  }

  // ======================================= View Assessment Functions Start =======================================
  viewDetails = (uuids) =>{
    const { allClients } = this.state;
    const extractProperties = (uuids, property) => {
      return uuids.map(UUID => allClients.find(({ uuid }) => uuid === UUID)[property]);
    };
    const areAllEqual = array => array.every(value => value === array[0]);
    
    const fullnameArray = extractProperties(uuids, 'fullname');
    const emailsArray = extractProperties(uuids, 'clientEmail');
    const companyArray = extractProperties(uuids, 'clientCompany');
    const otherDataArray = extractProperties(uuids, 'otherData');
    const projectNames = extractProperties(uuids, 'userCoach');
    const assessmentLanguageArray = extractProperties(uuids, 'assessmentLanguage');
    const assessment = extractProperties(uuids, 'assessmentTypeUntouched');
    const tokenType = extractProperties(uuids, 'tokenType');
    const reportToAutoSend = extractProperties(uuids, 'reportsToAutoSend');
    

    const projectName = areAllEqual(projectNames) ? projectNames[0] : '(differs across selection)';
    const fullname = areAllEqual(fullnameArray) ? fullnameArray[0] : '(differs across selection)';
    const clientEmail = areAllEqual(emailsArray) ? emailsArray[0] : '(differs across selection)';
    const clientCompany = areAllEqual(companyArray) ? companyArray[0] : '(differs across selection)';
    const clientOther = areAllEqual(otherDataArray) ? otherDataArray[0] : '(differs across selection)';
    const assessmentType = areAllEqual(assessment) ? assessment[0] : '(differs across selection)';
    const assessmentName = areAllEqual(assessment) ? utils.assessmentCodeToName(assessment[0]) : '(differs across selection)';
    const tokenTypes = areAllEqual(tokenType) ? tokenType[0] : '(differs across selection)';
    const reportsToAutoSend = areAllEqual(reportToAutoSend) ? this.correctReportNames(reportCodesToNames,reportToAutoSend[0].split(",")) : '(differs across selection)';
    const assessmentLanguage = areAllEqual(assessmentLanguageArray) ? assessmentLanguageArray[0] : '(differs across selection)';
      this.setState({
        openViewDetailsModal: true,
        project: projectName,
        fullname: fullname,
        email: clientEmail,
        company: clientCompany,
        other: clientOther,
        language: assessmentLanguage,
        selectValue: assessmentType,
        tokenType: tokenTypes,
        reportsToAutoSend: reportsToAutoSend,
        assessmentName: assessmentName
      });
    }

    setPronouns = (gender) => {
      return({
        "Male": 'heHim',
        "Female": 'sheHer',
        "Other": 'theyThem',
      }[gender]);
    }

    openAddCoupleModal =(uuids, selectedAssessments, a, b, c, d)=>{
      this.previousDateRemoved()

      const person1 = this.state.allClients.find(c => c.uuid === uuids[0])
      const person2 = this.state.allClients.find(c => c.uuid === uuids[1])



      this.setState({
        coupleModal:true,
        coupleUUIDS: uuids,
        person1Pronouns: this.setPronouns(person1.userGender),
        person2Pronouns: this.setPronouns(person2.userGender),
        person1Name: person1.clientName + ' ' + person1.clientSurname,
        person2Name: person2.clientName + ' ' + person2.clientSurname,
        pairCompleted: person1.userEnnea&&person1.userInstinct&&person1.userTriType&&person2.userEnnea&&person2.userInstinct&&person2.userTriType
      })
    }

    generateCouple =async()=>{
      const { pairCompleted, dueDate, coupleUUIDS, coupleType, person1Pronouns, person2Pronouns, pairTokenType } = this.state;
      if (pairCompleted&&!dueDate) {
        this.toastMessage("Please specify a due date.", "danger")
        return;
      }   
      if (!person1Pronouns||!person2Pronouns) {
        this.toastMessage("Please specify pronouns.", "danger")
        return;
      }
  
      this.closeModal()
      let postData = {
        uuids: coupleUUIDS,
        pronouns: [person1Pronouns, person2Pronouns],
        coupleType: coupleType, 
        tokenType: pairTokenType,
        reportDueDate: dueDate,
        reportCost: 2,
      }
      let added = await aserver.post(`api/v2/couples/${this.state.coachId}/newCouple`, postData);
      if (added.status === 200){
       this.openAlertModal("Success","Pair created. Check Pairs tab.", true)
      }
      else
        this.openAlertModal("Please note", added.data.error)
    }

    changeDate= (event) =>{
        this.setState({
          dueDate: event.target.value
        });
    }

    previousDateRemoved = () => {

      function addWorkingDays(startDate, daysToAdd) {
        const newDate = new Date(startDate);
        let daysAdded = 0;
        while (daysAdded < daysToAdd) {
          newDate.setDate(newDate.getDate() + 1);
          const dayOfWeek = newDate.getDay(); // 0 = Sunday, 6 = Saturday
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            daysAdded++;
          }
        }
        return newDate;
      }
      let minDate = addWorkingDays(new Date(), 2);
      this.setState({
        minDate: minDate.toISOString().substring(0,10),
        dueDate: "",
      })
    }

  // ======================================= View AssessmentFunctions End =======================================
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    if(localStorage.getItem("clipboardCancel") === "cancelled")
      this.setState({clipboardCancel: "cancelled"})
    if (localStorage.getItem("ReRoute")) {
      this.openClientModal("");
      localStorage.removeItem("ReRoute")
    }
    if (!this.state.hasMaturityAccreditation) {
      this.setState({
        selectValue: "ennea"
      })
    }

    this.populateProjects()
  }

  componentWillUnmount() {
    localStorage.removeItem("functionFilterId")
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render() {
    const classes = this.props.classes;
    const { downloadReportSubHeading, sendHistoryTitle, impersonator } = this.state;

    const pronounOptions = this.props.pronounSets ? (
        <>
          <option hidden value="">Choose pronouns...</option>
          {Object.entries(this.props.pronounSets).map(([key, data]) => (
            <option key={key} value={key}>
              {data.forms.join(' / ')}
            </option>
          ))}
        </>
      ) : <></>;    
  


    let disableAssessmentType = this.assessmentTypeDisabled()
    let disableAssessmentTypeOption = {color: this.assessmentTypeDisabled()?"#c0c0c0" : "none"}
    let assessmentOptions = <></>
    assessmentOptions = <>
      <div className="styled-select" style={{ display: this.state.importResultsCheck ? 'none' : 'block' }} >
        <select id="assessmentType" name="assessmentType" onChange={this.handleDropdownChange} value={this.state.selectValue} disabled={this.state.importResultsCheck} required>
          <option hidden>Type of Assessment</option>
          <option value="ennea">{utils.assessmentCodeToName('ennea')}</option>
          <option disabled={disableAssessmentType} style={disableAssessmentTypeOption} value="EIT">{utils.assessmentCodeToName('EIT')}</option>
          <option disabled={disableAssessmentType} style={disableAssessmentTypeOption} value="full">{utils.assessmentCodeToName('full')}</option>
        </select>
        <label>Assessment</label>
      </div>
    </>

    let languageOptions = <></>
      languageOptions = <>
                          <div className="styled-select input-wrapper-1">
                            <select id="dropdown" onChange={this.languageDropdown} style={{ textTransform: "capitalize" }} value={this.state.language} required>
                              {aserver.Languages.sort().map((info, i) => {
                                return (
                                  <option key={i} value={info}>{info.charAt(0).toUpperCase() + info.slice(1)}</option> 
                                )
                              })}
                            </select>
                            <label>Language</label>
                          </div>
                        </>

    let typeOfTokens =<></>
    typeOfTokens  = <>
                      <div className="styled-select" style={{ display: this.state.impersonator==="true" ? 'visible' : 'none' }} >
                        <select id="dropdown" onChange={this.handleDropdownChangeTokenType} value={this.state.tokenType} required>
                          {typeOfTokenOptions}
                        </select>
                        <label>Type of Token</label>
                      </div>
                    </>


    let Show = <></>

    if (this.state.assessmentInfo) {
      const groups = this.showAllowedReportsForAssessments(this.state.assessmentInfo)
      let possibleReportLanguages = aserver.ReportLanguages.filter(language=>this.state.assessmentInfo.find(a=>a.assessmentLanguage.toLowerCase()===language));
      if (!this.state.downloadReportModal)
        possibleReportLanguages = []; // only do language augmentation for report download, not report send
      let content = [];
      for (const [key, value] of Object.entries(groups)) {
        if (value.reports.length === 0)
          continue;
        if (value.groupHeading === "Available now") {
          var reports = [];
          for (let report of value.reports) {
            reports.push({
              code: report,
              displayName: reportCodesToNames[report]
            });
            if (report==='basic') {
              for (let language of possibleReportLanguages) {
                reports.push({
                  code: report+'.'+language.toLowerCase(),
                  displayName: reportCodesToNames[report] + ` (${utils.capitalize(language)})`
                });
              }
            }
          }
          for (let report of reports) {
            content.push(<>
              <input key={key} type="checkbox" onChange={this.handleChecked} id={report.code} value={report.code} disabled={this.state.disableCheckBox ? true : false} />
              <label className="sendReportLabel" htmlFor={report.code}>{report.displayName}</label> 
              <span style={{ color: this.state['statuscolor' + report.code] }}>{this.state['status' + report.code]}</span>
              <br></br>
            </>)
          }
        } else {
          content.push(<h3>{value.groupHeading}</h3>);
          content.push(<ul className="ulStyle">{value.reports.map(report => <li><label className="sendReportLabel">{reportCodesToNames[report]}</label></li>)}</ul>)
        }
      }
      Show = content;
    }

    let downloadReportButton = <></>

    if (this.state.downloadReportModalTitle === "Download Reports") {
      downloadReportButton = <><Button variant="contained" color="primary" type="submit" onClick={this.downloadReports}>Download Reports</Button></>
    } if (this.state.downloadReportModalTitle !== "Download Reports") {
      downloadReportButton = <><h3>Please wait...</h3><br></br><Button style={{ display: this.state.assessmentInfo.length === 1 ? "none" : "block" }} disabled={this.state.stopDownload} variant="contained" color="primary" type="submit" onClick={this.stopDownload}>{this.state.stopButtonTitle}</Button></>
    } if (this.state.downloadReportModalTitle === "Download Complete" || this.state.downloadReportModalTitle === "Download Stopped") {
      downloadReportButton = <><Button variant="contained" color="primary" type="submit" onClick={this.closeModal}>Ok</Button></>
    }


    let SendReportToCoach = <></>
    if (impersonator === "true") {
      SendReportToCoach =
        <>
          <div className="input-wrapper-2">
            <input className="input" type="email" name="coachEmailAddress" id="coachEmailAddress" onChange={this.handleChange} value={this.state.coachEmailAddress} autoFocus />
            <label className="edit" htmlFor="coachEmailAddress">Coach Email Address</label>
          </div>
        </>
    }

    let historyList = <>
      {this.state.historyData.map(historyItem => {
        var innards = [];
        var isInvitation = historyItem.hasOwnProperty("inviteType");
        var isReportsSent = !isInvitation;
        var showEmailFields = isReportsSent || (historyItem.inviteType === 'email');
        if (isInvitation) {
          if (historyItem.isReminder === "Yes")
            innards.push(<p key='1'><b>Reminder</b></p>);
          innards.push(<p key='2'><b>{historyItem.inviteType === 'email' ? 'Sent email' : 'Copied assessment link'}</b></p>);
        } else {
          innards.push(<p key='1'><b>Reports sent:</b> {historyItem.reportList.split(',').map(report => <li>{report}</li>)}</p>);
        }
        if (showEmailFields) {
          innards.push(<p key='3'><b>Recipient email:</b> {historyItem.destinationEmail}</p>);
          innards.push(<p key='4'><b>{historyItem.sentViaServer}</b></p>);
        }
        innards.push(<p key='5'><b>Date</b> {historyItem.createdAt}</p>);
        return (
          <Paper key={historyItem.createdAt} style={{ "border": "1px solid", "padding": "5px", "marginTop": "10px" }}>
            {innards}
          </Paper>
        )
      })}
    </>


    let listOfCompletedNames = <></>
    if (this.state.listOfCompletedAssessmentNames.length > 0) {
      listOfCompletedNames = <>
        <p>The following assessments have already been completed, and invites will NOT be sent to them:</p>
        <ul>{this.state.listOfCompletedAssessmentNames.map(name => <li>{name}</li>)}</ul>
      </>
    }

    let listOfReminderNames = <></>
    if ((this.state.listOfReminderNames.length > 0)) {
      listOfReminderNames = <><p>The following clients have been invited before - REMINDERs will be sent to them:</p>
        <ul>{this.state.listOfReminderNames.map(name => <li>{name}</li>)}</ul>
      </>
    }

    let listOfNotSentInvitesNames = <></>
    if (this.state.listOfNotSentInvitesNames.length > 0) {
      listOfNotSentInvitesNames = <><p>The following clients have not been invited before - invites will be sent to them:</p>
        <ul>{this.state.listOfNotSentInvitesNames.map(name => <li>{name}</li>)}</ul>
      </>
    }

    let isSCOComponent = this.props.isSecondaryComponent;
    
    let showAllColumnsDesktop = [
      { dataField: "infoTile", caption: "Info" },
      { dataField: "clientCompany", caption: "Company" },
      { dataField: "userCoach", caption: "Project" },
      { dataField: "results", caption: "Ennea Results" },
      { dataField: "scoreIMF", caption: "Maturity Results" },
      { dataField: "assessmentTypeDecorated", caption: "Assessment" },
      { dataField: "abbreviatedAssessmentLanguage", caption: "Lang" },
      { dataField: "tokenCreatedAt", caption: "Created" },
      { dataField: "guestRegisteredAt", caption: "Registered" },
      { dataField: "guestCompletedAtDisplay", caption: "Completed" }
    ];
  
    let showAllColumnsMobile = [
      { dataField: "mobileInfoTile", caption: "Info" },
      { dataField: "results", caption: "Ennea" },
      { dataField: "scoreIMF", caption: "Maturity" },
      { dataField: "guestCompletedAtDisplay", caption: "Completed" }
    ];

    let otherData = { dataField: "otherData", caption: "Other" };

    let secondaryCoachText =<></>
    if(this.state.selectedSCO_UUIDs.length>1){
      secondaryCoachText =  <>these {this.state.selectedSCO_UUIDs.length} assessments? After you do, the secondary</>
    }else{
      secondaryCoachText =  <>this assessment? After you do, the secondary</>
    }

    let tableFunctions = [
      { caption: 'Add Assessment for New Client', icon: <PersonAddIcon />, minRecordsRequired: 0, ourownonclick: this.openClientModal, addDropdown:true,},
      { caption: 'Add Assessment to Existing Client', icon: <PersonAddIcon />, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.openExistingTokenModal, addDropdown:true,},
      { caption: 'Add Pairs', icon: <PersonAddIcon />, minRecordsRequired: 2, maxRecordsRequired: 2, ourownonclick: this.openAddCoupleModal, addDropdown:true,},
      //{ caption: 'Add Athlete', icon: <PersonAddIcon />, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.openAddCoupleModal, addDropdown:true,},
      { caption: 'Import Results', icon: <PersonAddIcon />, minRecordsRequired: 0,maxRecordsRequired: 0, ourownonclick: this.openImportModal, addDropdown:true,},
      { caption: 'Import Results to Existing Client', icon: <PersonAddIcon />, minRecordsRequired: 1,maxRecordsRequired: 1, ourownonclick: this.openImportModal, addDropdown:true,},
      ...(isMobile?[]:[{ caption: 'Bulk Add Clients and Assessments', icon: <PersonAddIcon />, minRecordsRequired: 0, ourownonclick: this.openBulkAdd, addDropdown:true }]),
      { caption: 'Copy Assessment Link', icon: copyIcon, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.copyCodeToClipboard, frequentlyUsed: true,mainMobileButton:false },
      { caption: 'Send Invites/Reminders', icon: sendInviteIcon, minRecordsRequired: 1, ourownonclick: this.openPreInviteModal, frequentlyUsed: true, mainMobileButton:false},
      { caption: 'Send Reports', icon: sendReportIcon, minRecordsRequired: 1, ourownonclick: this.openSendReportModal, frequentlyUsed: true,mainMobileButton:false},
      { caption: 'Download Reports', icon: downloadIcon, minRecordsRequired: 1, ourownonclick: this.openDownloadReport, frequentlyUsed: true, mainMobileButton:false},
      { caption: 'View Details', icon: <DeleteForeverIcon />, minRecordsRequired: 1, ourownonclick: this.viewDetails, frequentlyUsed: false, mainMobileButton:false},
      ...((isMobile)?[]:[{ caption: 'Download Details', icon: <downloadIcon />, minRecordsRequired: 1, ourownonclick: this.downloadMailingDetails, frequentlyUsed: false }]),
      ...(isMobile?[]:[{ caption: 'Add To Team', icon: <GroupAddIcon />, minRecordsRequired: 1, ourownonclick: this.handleAddToTeam, addDropdown:true}]),
      ...(isMobile?[]:[{ caption: 'Combine', icon: <GetAppIcon />, minRecordsRequired: 2, maxRecordsRequired: 2, ourownonclick: this.openMakeHybridModal, frequentlyUsed: false}]),
      ...(isSCOComponent?[]:[{ caption: 'Assign SCO', icon: <GetAppIcon />, minRecordsRequired: 1, ourownonclick: this.openAssignSCOModal, frequentlyUsed: false, mainMobileButton:false, disabledCheck: r => !!r.fromAnotherCoach, disabledTooltip: 'Cannot assign SCO to assessments received from another coach.'}]),
      ...((isMobile||isSCOComponent)?[]:[{ caption: 'Wrap/Unwrap', icon: <AssignmentTurnedInIcon />, minRecordsRequired: 1, ourownonclick: this.openWrapUpModal, frequentlyUsed: false }]),
      { caption: 'Delete', icon: <DeleteForeverIcon />, minRecordsRequired: 1, ourownonclick: this.deleteAssessment, frequentlyUsed: false, mainMobileButton:false},
      { caption: 'Edit', icon: <EditIcon />, minRecordsRequired: 1, ourownonclick: this.edit, frequentlyUsed: false, mainMobileButton:false },


    ];

    if (this.props.scoMode==='given') {
      tableFunctions = [
        { caption: 'Revoke SCO', icon: removeIcon, minRecordsRequired: 1, ourownonclick: this.openRevokeSCOModal, frequentlyUsed: true}
      ];
      showAllColumnsDesktop.push({ dataField: "coachName", caption: "To Coach" });
      showAllColumnsMobile.push({ dataField: "coachName", caption: "To Coach" });
    }

    let routeStub = `api/v2/coaches/${this.state.coachId}/tokensX`;
    let route = routeStub + (isSCOComponent?`?mode=${this.props.scoMode}`:'');
    if ((!isSCOComponent)&&(this.props.hasReceivedSCOs)) {
      showAllColumnsDesktop.push({ dataField: "coachName", caption: "From Coach" });
      route = {
        callback: async function() {
          let ownAssessments = (await aserver.get(routeStub)).data;
          let scoAssessments = (await aserver.get(`${routeStub}?mode=received`)).data;
          return({ data: ownAssessments.concat(scoAssessments)});
        }
      }

    }

    function checkMissingField(fieldName, object) {
      if (object[fieldName])
        return(object[fieldName]);
      return(<span className="bulkUploadAlert">missing {fieldName}</span>);
    }

    function checkEmail(object) {
      if (object.invalidEmail)
        return(<span className="bulkUploadAlert">(invalid email)</span>)
      return('');
    }
        
    let filterButtons = this.props.hasReceivedSCOs
      ? utils.filterButtons
      : utils.filterButtons.filter(button => button.id !== 'filterSCO')
    
    return (
        <main className="app-content">
                <AephoriaTable
                  key={this.props.scoMode}
                  route={route}
                  massageData={this.massageData}
                  selectedData={this.selectedData}
                  onSelectionChanged={this.onSelectionChanged}
                  activeFilterButton={this.state.activateFilter}
                  filterButtons={filterButtons}
                  deleteConfig={
                    {
                      endpoint: 'api/v2/tokens',
                      pluralDisplayName: "Assessments",
                      displayCallback: function(record) {
                        return(record.fullname)
                      },
                      checkForReportRequested:false
                    }
                  }
                  updateLayout={this.props.updateLayout}
                  tableFunctions={tableFunctions}
                  tableName="Assessments"
                  displayFields={[...(this.state.devTest ? [{ dataField: "userToken", caption: "Token" }] : []),
                  ...(isMobile ? showAllColumnsMobile : showAllColumnsDesktop),
                  ...(!this.state.otherDataExists || (this.state.otherDataExists && isMobile) ? [] : [otherData])]} />    

                  {/*===================== Add to teams modal ===========================*/}
                  <Modal isOpen={this.state.addProjectModal} onClose={() => this.closeModal()}>
                    <h3>{this.state.assessmentModalTitle}</h3>
                    <div className="container">
                      {this.state.items.sort(function compare(a, b) {
                        var dateA = new Date(a.updatedAt || a.guestUpdatedAt);
                        var dateB = new Date(b.updatedAt || b.guestUpdatedAt);
                        return dateB - dateA;
                      }).map(item => {
                        return (
                          <div key={item.uuid}>
                            <input
                              type="checkbox"
                              checked={this.state.team === item.uuid}
                              value={item.uuid}
                              onChange={this.radioButttonChange}
                            />
                            <span>{item.name}</span>
                            <br />
                          </div>
                        );
                      })}
                    </div>
                   <Button variant="contained" color="primary" type="submit" disabled={this.state.addToTeamSubmitDisabled} onClick={this.state.assessmentModalSubmitFunction}>{this.state.assessmentModalSubmitCaption}</Button>
                 </Modal>
    

                {/*======================= Download Reports Modal ==============================*/}

                <Modal id="downloadReportModal" isOpen={this.state.downloadReportModal} onClose={this.state.downloadReportModalTitle === "Downloading Reports" ? null : () => this.closeModal()}>
                  <h2 >{this.state.downloadReportModalTitle}</h2>
                  <div>
                    {<p>{downloadReportSubHeading}</p>}
                  </div>
                  {Show}
                  {downloadReportButton}
                </Modal>


                {/* ========================== Send invites/reports Modal ==============================*/}
                <Modal isOpen={this.state.sendReportModal} onClose={() => this.closeModal()}>
                  <h2>{this.state.assessmentModalTitle}</h2>
                  <div style={{ display: !this.state.disableModal ? 'visible' : 'none' }}>
                    {SendReportToCoach}
                  </div>
                  <div style={{ display: !this.state.disableModal ? 'visible' : 'none' }}>
                    {Show}
                  </div>
                  <Button disabled={this.state.disableGmail} variant="contained" color="primary" type="submit" onClick={() => this.sendFunction(false)}>
                    <span style={{ display: this.state.disableGmail ? "none" : "block" }}><span style={{textTransform:"none"}}>Send from my email address</span></span>
                    <span style={{ display: this.state.disableGmail ? "block" : "none", fontSize: "1.2vh", textTransform: "none", color:"black" }}>Can't send from your email address because<br></br> more than one assessment has been selected.</span>
                  </Button>
                  <br></br>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.openPreviewModal()}><span style={{textTransform:"none"}}>Send from aim@aephoria.co.za</span></Button>
                </Modal>

                {/* ================== confirmation modal ===================*/}

                <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                  <h3>{this.state.confirmationHeading}</h3>
                  {this.state.confirmationModalText}
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.state.confirmationFunction(true)}>Ok</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                {/* ================== Open Information of Send Report / Report Send History  ========================*/}

                <Modal isOpen={this.state.openHistoryModal} onClose={() => this.closeModal()}>
                  <h3>{sendHistoryTitle}</h3>
                  <p style={{ display: this.state.noHistoryLogsAvailable ? "block" : "none" }}>No record of sent {this.state.historyType} were found. Reports could have been sent before 17 March 2022,<br></br> before sending was logged.</p>
                  <div id="reportSentModal" style={{ display: this.state.noHistoryLogsAvailable ? "none" : "block" }} >
                    {historyList}
                  </div>
                </Modal>

                {/* =========================Assigning SCO Modal=========================== */}

                <Modal isOpen={this.state.assignSCOModalOpen} onClose={() => this.closeModal()}>
                  <h2>Assign Secondary Ownership</h2>
                  <span>Enter Secondary Coach Email Address:</span>
                  <br></br>
                  <div className="input-wrapper-2">
                    <input className="input" type="email" name="secondaryCoachEmailAddress" id="secondaryCoachEmailAddress" maxLength="45" onChange={this.handleChange} value={this.state.secondaryCoachEmailAddress} style={{ "margin": "10px 0px", "padding": "8px 16px","minWidth":"100%"}} />
                    <label className="edit">Email</label>
                  </div>
                  <p style={{display:this.state.showInvalidEmailAddressText?"block":"none", color:"red"}}>Please enter a valid email address.</p>
                  <p>You will be assigning secondary coach ownership to this coach, for the {this.state.selectedAssessmentUUIDs.length} selected record(s).</p>
                  <p>Please take care when assigning SCO as you are sharing sensitive data that requires data protection to another party. If you do not yet have an agreement with the coach in question around use of sensitive personal information, please put this in place prior to assigning SCO rights.</p>
                  <p>You can revoke SCO at any time - on completion of a project or when sharing these clients is no longer necessary. Find the assessments that you have shared with other coaches on the "SCO Given" tab (which only appears once you have assigned SCO).</p>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.invalidEmailAddress?true:false} onClick={() => this.assignSCO()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                {/* ============= SCO Level Warning Modal ============= */}
                <Modal isOpen={this.state.scoLevelWarningModal} onClose={() => this.closeModal()}>
                  <h3>Warning</h3>
                  <p>The coach you are assigning SCO to does not have L2 (Maturity) accreditation, which is required to work with combined or maturity reports - would you still like to proceed?</p>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.confirmAssignSCO()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                <Modal isOpen={this.state.revokeSCOModal} onClose={() => this.closeModal()}>
                  <h2>Revoke Secondary Ownership</h2>
                  <p>Do you want to proceed with revoking secondary ownership on {secondaryCoachText} {this.state.uniqueCoachlist.length>1?"coaches":"coach"} <span style={{"color":"red"}}>{this.state.uniqueCoachlist.join(", ")}</span> will no longer be able to work with {this.state.selectedSCO_UUIDs.length>1?"them":"it"}.</p>
                  <p style={{"color":"red"}}>If {this.state.selectedSCO_UUIDs.length>1?"any of these clients are":"this client is"} in a team in {this.state.uniqueCoachlist.length>1?"one of these coaches'":"this coach's"} portal, revoking SCO will remove {this.state.selectedSCO_UUIDs.length>1?"them":"it"} from any team{this.state.selectedSCO_UUIDs.length>1?"s":""} that {this.state.selectedSCO_UUIDs.length>1?"don't":"doesn't"} have a report yet. {this.state.selectedSCO_UUIDs.length>1?"They'll":"It'll"} stay in any team whose report has already been supplied. Are you sure you want to continue?</p>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.revokeSCOProceedDisabled} onClick={() => this.revokeSCO()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                { /* ======================= Preview Modal ====================*/}
                <Modal isOpen={this.state.previewModal} onClose={() => this.closeModal()}>
                  <h2>Preview</h2>
                  <p>Sending {this.state.sendInviteOrReport ? "invite email" : "report email"} to {this.state.selected - this.state.listOfCompletedAssessmentNames.length} {this.state.selected > 1 ? "clients" : "client"}</p>
                  {/* todiscuss: why must we use BRs to split up the text? Why can't it just wrap the text?*/}
                  <p style={{ color: "red" }}>{this.state.previewExplanation.split('. ').map((line,i) => <span key={i}>{line}.<br></br></span>)}</p>
                  <div id="previewTextArea" contentEditable={false} className="editable"></div>
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.sendFunction(true)}>Proceed with Send</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel Send</Button>
                </Modal>

                {/* Pre Invite Modal */}
                <Modal isOpen={this.state.openPreInviteModal} onClose={() => this.closeModal()}>
                  <h2>Note</h2>
                  {listOfNotSentInvitesNames}
                  {listOfReminderNames}
                  {listOfCompletedNames}
                  <p style={{ display: this.state.noInviteToSend ? "block" : "none" }}>There's nothing to be done - there are no invites to be sent.</p>
                  <Button variant="contained" color="primary" type="submit" style={{ display: this.state.noInviteToSend ? "none" : "inline" }} onClick={() => this.openSendInvitesModal(this.state.clientUUIDS)}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                {/* ================= Edit modal  =======================*/}

                <Modal isOpen={this.state.editModal} onClose={() => this.closeModal()}>
                  <h3>Edit Assessment</h3>
                  <div className="edit-modal">
                  <h4 className="delineatedHeading" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>Client Details</h4>
                  <p style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>You can change the client specific fields - this will affect all assessments for this client</p>
                    {this.state.disableInputs && (
                    <>
                      <div className={`input-wrapper-1 addClientDiv ${this.state.blockFields ? 'disabled' : ''}`} >
                        <div className="tooltip-wrapper">
                          <input
                            type="text"
                            name="name"
                            id="name"
                            onChange={this.handleChange}
                            value={this.state.name}
                            disabled={this.state.blockFields}
                          />
                          {this.state.blockFields && (
                            <div className="tooltip-text">
                              Editing of this field is disabled after the assessment has been completed. If you want it changed, please contact Aephoria
                            </div>
                          )}
                        </div>
                        <label className="edit">Name</label>
                      </div>
                      <div className={`input-wrapper-1 addClientDiv ${this.state.blockFields ? 'disabled' : ''}`}>
                        <div className="tooltip-wrapper">
                          <input
                            type="text"
                            name="surname"
                            id="surname"
                            onChange={this.handleChange}
                            value={this.state.surname}
                            disabled={this.state.blockFields}
                          />
                          {this.state.blockFields && (
                            <div className="tooltip-text">
                              Editing of this field is disabled after the assessment has been completed. If you want it changed, please contact Aephoria
                            </div>
                          )}
                        </div>
                        <label className="edit">Surname</label>
                      </div>
               
                    <div className={`input-wrapper-1 addClientDiv ${this.state.blockFields ? 'disabled' : ''}`}>
                      <div className="tooltip-wrapper">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          onChange={this.handleChange}
                          value={this.state.email}
                          disabled={this.state.blockFields}
                        />
                        {this.state.blockFields && (
                          <div className="tooltip-text">
                            Editing of this field is disabled after the assessment has been completed. If you want it changed, please contact Aephoria
                          </div>
                        )}
                      </div>
                      <label className="edit">Email</label>
                    </div>
                    </>
                    )}
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="company" id="company" onChange={this.handleChange} value={this.state.company} />
                      <label className="edit">Company</label>
                    </div>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="other" id="other" onChange={this.handleChange} value={this.state.other} maxLength="250"/>
                      <label className="edit">Other</label>
                    </div>
                    <p style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>You can change assessment specific fields for the selected assessment(s)</p>
                    <div className="input-wrapper-1 addClientDiv">
                        <ProjectSelect 
                          coachProjects={this.state.coachProjects}
                          value={this.state.projectName} 
                          onSelect={(value) => this.setState({ project: value })} 
                        />                        
                    </div>
                    <div className="styled-select">
                    <select
                      id="dropdown"
                      onChange={this.languageDropdown}
                      style={{ textTransform: "capitalize" }}
                      value={this.state.language || ''}
                      required
                    >
                      {(!this.state.language || this.state.language === '') && (
                        <option value=""></option>
                      )}
                      {aserver.Languages.sort().map((info, i) => (
                        <option key={i} value={info}>
                          {info.charAt(0).toUpperCase() + info.slice(1)}
                        </option>
                      ))}
                    </select>
                      <label>Language</label>
                    </div>
                    {this.state.impersonator === "true" && false && ( //#958
                      <div className="styled-select">
                        <select
                          id="dropdown"
                          onChange={this.handleDropdownChangeTokenType}
                          value={this.state.tokenType || ''}
                          required
                        >
                          {(!this.state.tokenType || this.state.tokenType === '') && (
                            <option value=""></option>
                          )}
                          {typeOfTokenOptions}
                        </select>
                        <label>Token Type</label>
                      </div>
                    )}
                    {this.state.isThereMultipleReports?<><span>Note: Reports to auto-send varies across selection</span><br></br></>:null}
                    {this.generateAutoSendCheckboxes(this.state.ShowEditAssessments)}
                    <Button variant="contained" color="primary" type="submit" onClick={() => this.saveEditedChanges()}>Update</Button>

                  </div>

                </Modal>

                <Modal isOpen={this.state.openMakeHybridModal} id="hybridTable" onClose={() => this.setState({openMakeHybridModal:false})}>
                  <h2>Combine Assessments for {this.state.hybridizeName}</h2>
                  <div className="combineLayout">
                  {this.state.assessmentsToHybridize.map((info, i) => {
                        return (
                          <div className="infoToDisplay">
                            <h3 style={{marginBottom:"0"}}><u>{info.assessmentTypeDisplay}<br></br>Assessment</u></h3>
                            <div>Completed: <b>{info.guestCompletedAt.slice(0, 10)}</b></div>
                            <br></br>
                            <div>Ennea: <b>{info.results?info.results:"n/a"}</b></div>
                            <div>Maturity: <b>{info.scoreIMF?info.scoreIMF:"n/a"}</b></div>
                            <br></br>
                            <div style={{cursor:"pointer"}} onClick={info.assessmentType === 'IMf'?null:() => this.handleCheckboxChange(info.uuid, 'chooseEnneagram')}>Use this Ennea 
                              <input
                                style={{"margin":"0 6px"}}
                                type="checkbox"
                                disabled={info.assessmentType === 'IMf'}
                                checked={this.isSelected(info.uuid, 'chooseEnneagram')}
                                onChange={() => this.handleCheckboxChange(info.uuid, 'chooseEnneagram')}
                              />
                            </div>
                            <div style={{cursor:"pointer"}} onClick={info.assessmentType === 'Enneagram'?null:() => this.handleCheckboxChange(info.uuid, 'chooseIMf')}>Use this Maturity
                              <input
                                style={{"margin":"0 6px"}}
                                disabled={info.assessmentType === 'Enneagram'}
                                type="checkbox"
                                checked={this.isSelected(info.uuid, 'chooseIMf')}
                                onChange={() => this.handleCheckboxChange(info.uuid, 'chooseIMf')}
                              />
                            </div>
                            <br></br>
                            <br></br>
                          </div>
                        );
                      })}

                  </div>
                 
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.disableProccedButton} onClick={() => this.hybridize()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.setState({openMakeHybridModal:false})}>Cancel</Button>
                </Modal>

                {/* ============================= Clients Modals start==============================================================================*/}

                  
                <Modal isOpen={this.state.modalIsOpen} onClose={() => this.closeModal()}>
                  <h3>{this.state.coachModalTitle}</h3>
                  <div className="edit-div">
                    <h5 className="delineatedHeading" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>Client Details</h5>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="name" id="name" onChange={this.handleChange} value={this.state.name} disabled={this.state.disabled} autoFocus />
                      <label className="edit">Name</label>
                    </div>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="surname" id="surname" onChange={this.handleChange} value={this.state.surname} disabled={this.state.disabled} />
                      <label className="edit">Surname</label>
                    </div>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="email" name="email" id="email" onChange={this.handleChange} value={this.state.email} disabled={this.state.disabled} />
                      <label className="edit">Email</label>
                    </div>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="company" id="company" onChange={this.handleChange} value={this.state.company} />
                      <label className="edit">Company</label>
                    </div>
                    <div className="input-wrapper-1 addClientDiv" style={{ display: this.state.disableInputs ? 'visible' : 'none' }}>
                      <input type="text" name="other" id="other" onChange={this.handleChange} value={this.state.other} maxLength="250"/>
                      <label className="edit">Other</label>
                    </div>
                    <h4 className="delineatedHeading" style={{ display: this.state.showInfo ? 'visible' : 'none' }}>Previous Assessments:</h4>
                    {this.state.clientListOfAssessments.length > 0 ? <div className="miniTable" style={{ display: this.state.showInfo ? 'visible' : 'none' }}><table>
                      <tbody >
                        {this.state.clientListOfAssessments.map((info, i) => {
                          return (
                            <tr key={i} className="test-td">
                              <td style={{ textAlign: "start" }}>{info.assessmentType}, assigned {info.createdAt}, {info.completedAt !== '-' ? "completed " + info.completedAt : "not completed"}</td>
                            </tr>
                          )
                        }
                        )}
                      </tbody>
                    </table> </div> : <p style={{ display: this.state.showInfo ? 'visible' : 'none' }}>Client has no previous assessments.</p>}
                    <div style={{ display: !this.state.disableTypeOfTest ? 'visible' : 'none' }}>
                      <h5 className="delineatedHeading">Assessment Details</h5>
                      <div className="input-wrapper-1 addClientDiv">
                        <ProjectSelect 
                          coachProjects={this.state.coachProjects} 
                          value={this.state.projectName} 
                          onSelect={(value) => this.setState({ project: value })} 
                        />                        
                      </div>
                        
                      <span style={{ display: this.state.importResultsCheck ? 'none' : 'block' }}>{typeOfTokens}</span>
                      {languageOptions}
                      {assessmentOptions}
                      {this.generateAutoSendCheckboxes(this.state.selectValue)}
                    </div>
                  </div>
                  <p style={{marginTop:"0", display: localStorage.getItem("singleNotification") === "0" ? "block" : "none" }} >To receive notifications when this assessment is completed / marked, tick the checkboxes in your User Profile (click on your name at the top left), in the Notification Preferences section.</p>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.addClientButton} onClick={this.state.coachModalSubmitFunction}>{this.state.coachModalSubmitCaption}</Button>
                </Modal>

                {/* ====================================Import Results Modal ======================================*/}

                <Modal isOpen={this.state.importResultsModal} onClose={() => this.closeImportModal()}>
                   <h3>Import Results</h3>
                    {this.state.selected!==1 && (
                        <>
                          <h5
                            className="delineatedHeading"
                            style={{
                              display: this.state.disableInputs ? "visible" : "none"
                            }}
                          >
                            Client Details
                          </h5>
                          <div className="input-wrapper-1 addClientDiv">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              onChange={this.handleChange}
                              value={this.state.name}
                              autoFocus
                            />
                            <label className="edit">Name</label>
                          </div>
                          <div className="input-wrapper-1 addClientDiv">
                            <input
                              type="text"
                              name="surname"
                              id="surname"
                              onChange={this.handleChange}
                              value={this.state.surname}
                            />
                            <label className="edit">Surname</label>
                          </div>
                          <div className="input-wrapper-1 addClientDiv">
                            <input
                              type="email"
                              name="email"
                              id="email"
                              onChange={this.handleChange}
                              value={this.state.email}
                            />
                            <label className="edit">Email</label>
                          </div>
                          <div className="input-wrapper-1 addClientDiv">
                            <input
                              type="text"
                              name="company"
                              id="company"
                              onChange={this.handleChange}
                              value={this.state.company}
                            />
                            <label className="edit">Company</label>
                          </div>
                          <div className="input-wrapper-1 addClientDiv">
                            <input
                              type="text"
                              name="other"
                              id="other"
                              onChange={this.handleChange}
                              value={this.state.other}
                              maxLength="250"
                            />
                            <label className="edit">Other</label>
                          </div>
                        </>
                      )}

                     <div className="input-wrapper-1 addClientDiv">
                        <ProjectSelect 
                          coachProjects={this.state.coachProjects} 
                          value={this.state.projectName} 
                          onSelect={(value) => this.setState({ project: value })} 
                        />                        
                      </div>
                    {languageOptions}
                    <p>Enter the enneagram ranking as nine numbers separated by commas. The first three numbers must correspond to the ordered trifix. (eg 2,1,5,9,3,6,7,8,4 for an Ennea 2 with 125 trifix):</p>
                    <div className="input-wrapper-1 addClientDiv" style={{width:"100%"}}>
                      <input type="text" name="enneaRankingCSV" id="enneaRankingCSV" onChange={this.handleChange} value={this.state.enneaRankingCSV} maxLength="250" style={{width:"100%"}}/>
                      <label className="edit">Enneagram Ranking</label>
                    </div>
                    <p>Instinct Scores</p>
                    <div className="input-wrapper-1 sliderDiv">
                      <IOSSlider aria-label="ios slider" name="scoreSP" defaultValue={this.state.scoreSP} marks={marks} valueLabelDisplay="on" onChangeCommitted={this.sliderChange("scoreSP")} />
                      <label className="edit left">SP</label>
                    </div>
                    <br></br>
                    <div className="input-wrapper-1 sliderDiv">
                      <IOSSlider aria-label="ios slider" name="scoreSO" defaultValue={this.state.scoreSO} marks={marks} valueLabelDisplay="on" onChangeCommitted={this.sliderChange("scoreSO")} />
                      <label className="edit left">SO</label>
                    </div>
                    <br></br>
                    <div className="input-wrapper-1 sliderDiv">
                      <IOSSlider aria-label="ios slider" name="scoreSX" defaultValue={this.state.scoreSX} marks={marks} valueLabelDisplay="on" onChangeCommitted={this.sliderChange("scoreSX")}/>
                      <label className="edit left">SX</label>
                    </div>
                    <Button variant="contained" color="primary" type="submit" onClick={() => this.importResults()}>Import</Button>

                </Modal>

                {/* =========================== Add bulk clients modal ========================= */}
                <Modal isOpen={this.state.openBulkModal} onClose={() => this.closeBulkUploadModal()}>
                  <h3>{this.state.coachModalTitle}</h3>
                  <form id="addBulkForm" name="addBulkForm">
                    <p>Upload Excel spreadsheet with client name, surname, email, company columns. A template for the spreadsheet can be downloaded <a className="urlLink" href={process.env.PUBLIC_URL + "/clients_template.xlsx"}>here</a>.</p>
                    <h5 className="delineatedHeading">Client Details</h5>
                    <input id="spreadsheet" name="spreadsheet" type="file" ref={this.fileInputRef} onChange={this.handleFileChange} />
                    <h5 className="delineatedHeading">Assessment Details</h5>
                    <div className="input-wrapper-1 addClientDiv">
                        <ProjectSelect 
                          coachProjects={this.state.coachProjects} 
                          onSelect={(value) => this.setState({ project: value })} 
                        />                        
                      </div>
                    {typeOfTokens}
                    {languageOptions}
                    {assessmentOptions}
                    {this.generateAutoSendCheckboxes(this.state.selectValue)}
                    <p style={{marginTop:"0", display: localStorage.getItem("bulkNotification") === "0" ? "block" : "none" }} >To receive notifications when this assessment is completed / marked, tick the checkboxes in your User Profile (click on your name at the top left), in the Notification Preferences section.</p>
                  </form>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.addClientButton} onClick={this.state.coachModalSubmitFunction}>{this.state.coachModalSubmitCaption}</Button>
                </Modal>

                <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                  <h3>{this.state.confirmationHeading}</h3>
                  {this.state.confirmationModalText}
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.state.confirmationFunction(true)}>Ok</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                <Modal isOpen={this.state.clipboardModal} onClose={() => this.closeModal()}>
                  <h2>Note</h2>
                  <p>The assessment link has been copied to the clipboard, and with this, the assessment has been flagged as having an invitation sent - so please do send that assessment link to the client in some way.</p>
                  <input type="checkbox" checked={this.state.clipboardCancel === 'cancelled'} onChange={e => this.checkPreferences(e)} name="clipboardCancel" id="clipboardCancel" value="cancelled" />                      
                  <label className="sendReportLabel" htmlFor="clipboardCancel">I don't want to see this again.</label>
                  <br></br>                  
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Ok</Button>
                </Modal>


                <Modal isOpen={this.state.showFailedDownloadModal} onClose={() => this.closeModal()}>
                  <h2>Failed</h2>
                  <p>The following report(s) could not be generated. The Aephoria team has been notified and will be in touch.</p>
                  <ul>
                    {this.state.failedDownloads.map((download, index) => (
                      <li key={index}>{download}</li>
                    ))}
                  </ul>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Ok</Button>
                </Modal>

                <Modal isOpen={this.state.showDuplicateUpload} onClose={() => this.closeModal()}>
                  <h2>Duplicate Uploads</h2>
                  <p>Note, the following clients already have assessments:</p>
                  <ul>
                    {this.state.duplicatedGuests.map((guest) => (
                    <>
                      <li key={guest.name}>{guest.name} {guest.surname} ({guest.email}) {assessmentTypes[guest.lastAssessmentType]} {guest.lastAssessment}</li>
                    </>
                    ))}
                  </ul>
                  <p>If you really wish to add new assessments for them, click Proceed. Otherwise, click Cancel, edit the spreadsheet to remove the existing clients, and upload the edited spreadsheet.</p>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.uploadClientSpreadsheet(true)}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                <Modal isOpen={this.state.openViewDetailsModal} onClose={() => this.closeModal()}>
                  <h2>Details</h2>
                    <span className="viewModalSpan"><b>Name:</b> {this.state.fullname}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Email:</b> {this.state.email}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Company:</b> {this.state.company}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Other:</b> {this.state.other?this.state.other:"(not specified)"}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Language:</b> {this.capitalizeFirstLetter(this.state.language)}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Assessment Type:</b> {this.state.assessmentName}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Token Type:</b> {this.capitalizeFirstLetter(this.state.tokenType)}</span>
                    <br></br>
                    <span className="viewModalSpan"><b>Auto-send reports: </b></span>
                    {Array.isArray(this.state.reportsToAutoSend) ? (
                      this.state.reportsToAutoSend.filter(report => report.trim() !== "-" && report.trim() !== "").length > 0 ? (
                        <ul style={{ margin: "0" }}>
                          {this.state.reportsToAutoSend.filter(report => report.trim() !== "-" && report.trim() !== "").map((report, index) => (
                            <li key={index}>{report}</li>
                          ))}
                        </ul>
                      ) : (
                        <span className="viewModalSpan">No</span>
                      )
                    ) : (
                      <span className="viewModalSpan">{this.state.reportsToAutoSend} </span>
                    )}
                    <br/>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Ok</Button>
                </Modal>

                <Modal isOpen={this.state.htmlReportsModalContent?true:false} onClose={() => this.closeModal()}>
                  {this.state.htmlReportsModalContent}
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Ok</Button>
                </Modal>

                <Modal isOpen={this.state.coupleModal} onClose={() => this.closeModal()}>
                  <h2>Add Pair</h2>
                  <p>Note: The pair report will cost 2 tokens to generate.</p>
                  <p>A report can take up to two working days to become available.</p>
                  <br></br>
                  <div className="styled-select">
                      <select
                        id="person1Pronouns"
                        value={this.state.person1Pronouns}
                        onChange={this.handleDropdownChangePerson1Pronouns}
                      >
                        {pronounOptions}
                      </select>
                      <label>Pronouns for {this.state.person1Name}</label>
                  </div>
                  <div className="styled-select">
                      <select
                        id="person2Pronouns"
                        value={this.state.person2Pronouns}
                        onChange={this.handleDropdownChangePerson2Pronouns}
                      >
                        {pronounOptions}
                      </select>
                      <label>Pronouns for {this.state.person2Name}</label>
                  </div>

                  <div className="styled-select">
                      <select
                        id="coupleType"
                        value={this.state.coupleType}
                        onChange={this.handleDropdownChange}
                      >
                        <option value="Romance">Romance</option>
                        {/*<option value="Athlete">Athlete</option>*/}
                        <option value="Professional Pairs">Professional</option>
                      </select>
                      <label>Report Type</label>
                  </div>
                  <div className="styled-select" style={{ display: this.state.impersonator==="true" ? 'visible' : 'none' }} >
                    <select id="dropdown" onChange={this.handleDropdownChangePairTokenType} value={this.state.pairTokenType} required>
                      <option hidden>Type Of Token</option>
                      <option value="paid">Billable</option>
                      <option value="marketing">Marketing</option>
                      <option value="accreditation">Accreditation</option>
                    </select>
                    <label>Type of Token</label>
                  </div>

                  {this.state.pairCompleted?
                  <div className="input-wrapper-1 addClientDiv" >
                    <input type="date" id="date-picker" name="requestDate" min={this.state.minDate} onChange={this.changeDate}/>
                    <label className="edit">Due Date</label>
                  </div>:
                  <div><p>
                    You cannot specify a due date, because the partners have not yet both completed the assessment.
                    </p><p>
                    Aephoria will provide the results within two business days of completion.
                    </p>
                  </div>
                  }
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.generateCouple()}>Create</Button>
                </Modal>


                {/*================================= This is the toast modal ======================================*/}

                <Toast
                  level={this.state.level}
                  message={this.state.message}
                  visible={this.state.showToast}
                />

                {/*==================== This is the new alertModal===================== */}

                <AlertModal
                  message={this.state.alertMessage}
                  modalTitle={this.state.alertModalTitle}
                  isOpen={this.state.openAlertModal}
                  showClose={this.state.refresh?() => this.refreshTable():() => this.closeModal()}
                >
                  <br style={{ display: this.state.successModalText ? "visible" : "none" }}></br>
                  <p style={{ display: this.state.successModalText ? "visible" : "none" }} className="delineatedHeading">{this.state.successModalText}</p>
                  <div style={{ display: this.state.failModalText.length > 0 ? "visible" : "none" }} className="miniTable">
                    <table>
                      <tbody >
                        {this.state.failModalText.map(info => {
                          return (
                            <p>{info}</p>
                          )
                        }
                        )}
                      </tbody>
                    </table>
                  </div>
                </AlertModal>

                <AlertModal
                  message={this.state.alertMessage}
                  modalTitle={this.state.alertModalTitle}
                  isOpen={this.state.openEditModal}
                  showClose={() => this.refreshTable()}
                >
                  <div className="miniTable">
                    <table>
                      <tbody >
                        {this.state.editModalArray.map(info => {
                          return (
                            <p>{info}</p>
                          )
                        }
                        )}
                      </tbody>
                    </table>
                  </div>
                </AlertModal>

                <AlertModal
                  message={this.state.warningMessage}
                  modalTitle={this.state.warningTitle}
                  isOpen={this.state.openWarningModal}
                  showClose={() => this.closeOnlyOneModal()}
                >
                  <div style={{ display: this.state.failModalText.length > 0 ? "visible" : "none" }} className="miniTable">
                    <table>
                      <tbody >
                        {this.state.failModalText.map(info => {
                          return (
                            <p>{checkMissingField('name', info)} {checkMissingField('surname', info)} {checkMissingField('email', info)} {checkEmail(info)}</p>
                          )
                        }
                        )}
                      </tbody>
                    </table>
                  </div>
                </AlertModal>

          <LoadingBackdrop open={this.state.openBackdrop}>
            <div style={{ width: "35%", display: this.state.showProgressBar ? "block" : "none" }}>
              <ProgressBar bgcolor={"#98CA3F"} completed={this.state.completed} />
            </div>
          </LoadingBackdrop>
        </main>
    );
  }
}
// eslint-disable-next-line
export default (props) => {
  const classes = useStyles();
  return (
    <Assessments classes={classes} {...props}/>
  )
};